import Vue from "vue";
import Enumerable from "linq";
import { baseVueController } from "./baseVueController";
import { screenCtrlEntity } from "./entity/screenCtrlEntity";
import { util, retailerConfig, GetEditInfo, cmnPart } from "./index";
import * as es6promise from "es6-promise";

import * as sonbpIfconst from "./sonbpIf/base/constants";
import * as idbEdit from "./entity/idb/editInfo";
import { common, constDialogMessage, dialogUtil, idb, ui } from "./util";
import { Logger } from "./util/logger";
import { MultiTab } from "./util/multitab";
//import { set } from "vue/types/umd";

import { EditConst, editModeKind, EDIT_MODE_KIND, kumihanHv, KUMIHAN_HV } from "./edit/edit.const";
import { initTempResponseEntity, photoControll, photoFrame, senderTranEntityEx, uploadPhoto } from "./edit/edit.entity";
import { editStrage, asyncWhenApply } from "./edit/edit.tool";
import { sonbpIFContoroller, itemVenderProperty } from "./edit/edit.sonbp_if";
import * as edLogic from "./edit/index";
import { GaijiLogic } from "./Gaiji/edit.GaijiLogic";
import { SSO } from "./util/sso";
import { AdjustRecord } from "./util/adjustRecord";


// gigya
declare var gigya: any;


//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * 編集画面コントローラクラス
 * */
export class editController extends baseVueController {

// #region ■定数
    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------
    /**
     * VueオブジェクトをバインドするID
     */
    private readonly ELEMENT_NAME: string = "#editController";

    /**
     * テンポラリデータ初期化(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_INITTEMP: string = "Edit/InitTemp";
    /**
     * 編集情報取得(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_GETEDITINF: string = "Edit/GetEditInfo";
    /**
     * スタンプサムネイル取得(WebAPI)呼び出しURL
     */
    //private readonly WEBAPI_URL_GETSTAMPIMAGE: string = "Edit/GetStampImage";
    /**
     * 画像存在チェック(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_CHECKUPLOADIMAGES: string = "Edit/CheckUploadImages";

    /**
     * 画像取得URLの補完用
     */
    private readonly URL_GETIMAGE: string = "/posca/img/";

    /**
     * スタンプカテゴリ：全部
     */
    private readonly STAMP_CATEGORY_ALL: string = "全表示";

// #endregion

// #region ■変数
    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 認証トークン 
     */
    private authToken: string;

    /**
     * 組版トークン 
     */
    private kumihanToken: string;

    /**
     * タイプ記号
     */
    private frameId: string;

    /**
     * 操作方法 URL
     */
    private operationHelpUrl: string;

    /**
     * ロゴ１ URL
     */
    private _logo1Url: string;
    /**
     * ロゴ２ URL
     */
    private _logo2Url: string;

    /**
     * プリント領域について URL
     */
    private printWarningUrl: string;

    /**
     * アップロード画像一覧（Vueバインド用）
     */
    private uploadPhotoList: uploadPhoto[];

    /**
    * アップロードMyステッカー画像一覧（Vueバインド用）
    */
    private uploadMyStampList: uploadPhoto[];

    /**
     * アップロード手書きスタンプ画像一覧（Vueバインド用）
     */
    private uploadTegakiStampList: uploadPhoto[];

    /**
     * 画面制御関連のコンフィグ値
     */
    private screenCtrl: screenCtrlEntity;

    /**
     * 編集モード
     */
    public editMode: editModeKind;

    /**
     * sonbpIF関連操作
     */
    private sonbpIfController: sonbpIFContoroller;

    /**
     * WebAPI[Edit/GetEditInfo]のレスポンスのdata部
     */
    public editInfo: GetEditInfo.GetEditInfoResponseEntity;

    /**
     * 初期化処理完了フラグ
     */
    private loadComplited: boolean;

    /**
     * ガイダンス画像URLリスト
     */
    private guidanceImgSrcList: string[];

    /**
     * オブジェクト配置有効領域
     */
    private putRange: cmnPart.putRange;

    /**
     * オブジェクト配置有効領域（スタンプ）
     */
    private putRangeStamp: cmnPart.putRangeStamp;

    /**
     * ページエリアオフセット情報
     */
    private pageAreaOffset: cmnPart.AreaCoordinate;

    /**
     * F5リロードアクセス？
     */
    private doReloadedAccess: boolean;

    /**
     * beforeunloadイベント時の sessionStorageへの書き込み要否フラグ
     */
    public doUnloadEventFunc: boolean;

    /**
     * リサイズ処理実行許可フラグ
     */
    private allowResizeFunc: boolean;

    /**
     * 画像操作のロジック
     */
    private _objectManiLogic: edLogic.ObjectManiLogicClass;
    private _photoLogic: edLogic.UploadImageLogic.PhotoLogicClass;
    private _myStampLogic: edLogic.UploadImageLogic.MyStampLogicClass;
    private _tegakiStampLogic: edLogic.UploadImageLogic.TegakiStampLogicClass;
    private _mstStampLogic: edLogic.UploadImageLogic.MstStampLogicClass;
    private _senderLogic: edLogic.SenderLogicClass;
    private _greetingLogic: edLogic.GreetingLogicClass;

    /**
     * 外字一覧のロジック
     */
    public _gaijiLogic: GaijiLogic;

    /**
     * 保存処理のロジック
     */
    public _saveLogic: edLogic.SaveLogicClass;


// #endregion

// #region ■プロパティ
    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------
    /**
     * 画面制御関連のコンフィグ値
     */
    public set ScreenCtrl(screenCtrl: screenCtrlEntity) {
        this.screenCtrl = screenCtrl;
    }
    public get ScreenCtrl(): screenCtrlEntity {
        return this.screenCtrl;
    }

    /**
    * リテーラ別設定情報
    */
    public set RetailerConfig(retailerConfig: retailerConfig.retailerConfigEntity) {
        this._retailerConfig = retailerConfig;
    }
    public get RetailerConfig(): retailerConfig.retailerConfigEntity {
        return this._retailerConfig;
    }

    /**
     * オブジェクト配置有効領域
     */
    public set PutRange(putRange: cmnPart.putRange) {
        this.putRange = putRange;
    }

    /**
     * オブジェクト配置有効領域（スタンプ）
     */
    public set PutRangeStamp(putRangeStamp: cmnPart.putRangeStamp) {
        this.putRangeStamp = putRangeStamp;
    }

    /**
     * ページエリアオフセット情報
     */
    public set PageAreaOffset(pageAreaOffset: cmnPart.AreaCoordinate) {
        this.pageAreaOffset = pageAreaOffset;
    }

// #endregion

// #region ■コンストラクタ
    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    constructor() {
        super();

        this.frameId = "-";
        this.editMode = EDIT_MODE_KIND.SET_PHOTO;
        this.loadComplited = false;
        this.allowResizeFunc = false;

        this.uploadPhotoList = [];
        this.uploadMyStampList = [];
        this.uploadTegakiStampList = [];

        // 画像操作のロジック
        this._objectManiLogic = new edLogic.ObjectManiLogicClass(this);
        this._photoLogic = new edLogic.UploadImageLogic.PhotoLogicClass(this, this.uploadPhotoList);
        this._myStampLogic = new edLogic.UploadImageLogic.MyStampLogicClass(this, this.uploadMyStampList);
        this._tegakiStampLogic = new edLogic.UploadImageLogic.TegakiStampLogicClass(this, this.uploadTegakiStampList);
        this._mstStampLogic = new edLogic.UploadImageLogic.MstStampLogicClass(this);
        this._senderLogic = new edLogic.SenderLogicClass(this);
        this._greetingLogic = new edLogic.GreetingLogicClass(this);

        // 外字
        this._gaijiLogic = new GaijiLogic();

        // 保存処理
        this._saveLogic = new edLogic.SaveLogicClass(this);


        this.doReloadedAccess = false;
        this.doUnloadEventFunc = true;
    }

// #endregion

// #region ■メソッド（メイン処理全般）
    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------
    /**
     * 初期化メソッド
     * */
    public init(): void {

        // タッチイベント無効化(sonbp以外)
        document.body.addEventListener("touchstart", function (e) {
            if (e.touches && e.touches.length > 1) {
                e.preventDefault();
            }
        }, { passive: false });
        document.body.addEventListener("touchmove", function (e) {
            if (e.touches && e.touches.length > 1) {
                e.preventDefault();
            }
        }, { passive: false });

        Logger.debug("ua [" + window.navigator.userAgent.toLowerCase() + "]")

        // sonbpIfコントローラ初期化
        this.sonbpIfController = new sonbpIFContoroller(this._usePcDesign);

        // 複数タブ禁止
        const multiTabCheck = () => {
            MultiTab.forbiddenMultiTab(() => {
                dialogUtil.createErrorDialog(constDialogMessage.WARNING_MULTITAB_FORBIDDEN
                    , () => { }
                    , null
                    ,true
                );
                this._vue.$data.Show.FirstGuidance = false;
            })
        }
        setInterval(multiTabCheck, MultiTab.INTERVAL);

        // エラー時のボタン遷移先
        this.SetErrorPageInfo();

        Logger.log("初期化メソッド 開始");

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // gigyaイベントリスナー登録
        if (this._retailerConfig.id == "0") {
            gigya.socialize.addEventHandlers({
                onLogin: util.common.onLoginHandlerWithSave
                //onHide: util.common.onHideHandler
            });
        }

        // リテーラ別の初期処理
        this.initRetailer();

        // F5リロード判定
        this.doReloadedAccess = this.doReloaded();
        // F5リロード監視
        this.unloadHandlerInit();

        if (this._usePcDesign) {
            // PC用
            // vueオブジェクト生成
            this.createVueForPc()
        }
        else {
            // SP用
            // vueオブジェクト生成
            this.createVueForSp()
        }


        // 画像処理準備
        this._objectManiLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._photoLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._myStampLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._tegakiStampLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._mstStampLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._senderLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);
        this._greetingLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);

        // 外字処理準備
        this._gaijiLogic.Init(this._vue);

        // 保存処理
        this._saveLogic.init(this._vue, this.sonbpIfController, this._usePcDesign, this.authToken);


        // ウィンドウのリサイズイベントハンドラ登録
        this.resizeWindowInit();

        Logger.log("初期化メソッド 終了");
    }

    /**
     * F5リロードイベントとして[beforeunload]イベントを監視
     * */
    private unloadHandlerInit(): void {

        let that: editController = this;
        let func = function () {
            that.unloadHandlerFunc(that);
        };
        window.removeEventListener('beforeunload', func);
        window.addEventListener('beforeunload', func);
    }

    /**
     * [beforeunload]イベント処理本体
     * @param contoroller ：editController
     */
    private unloadHandlerFunc(contoroller: editController): void {
        if (contoroller.doUnloadEventFunc) {
            const dtNow: Date = new Date();
            sessionStorage.setItem(EditConst.SESSION_STORAGE_KEY_RELOADED, dtNow.toUTCString());
        }
    }

    /**
     * F5リロード判定
     */
    private doReloaded(): boolean {

        // 取得
        const beforeunloadVal: string = sessionStorage.getItem(EditConst.SESSION_STORAGE_KEY_RELOADED);
        Logger.debug("beforeunload [" + beforeunloadVal + "]");
        // クリア
        sessionStorage.setItem(EditConst.SESSION_STORAGE_KEY_RELOADED, "");

        return beforeunloadVal ? true : false;
    }

    /**
     * F5リロード判定
     * (IE と safari は未対応)
     */
    private doReloadedForWin(): boolean {

        let result: boolean = false;

        if (!performance) {
            return result;
        }
        if (!performance.getEntriesByType) {
            return result;
        }
        if (typeof performance.getEntriesByType !== "function") {
            return result;
        }

        const nagigationList: PerformanceEntryList = performance.getEntriesByType("navigation");
        if (nagigationList) {

            nagigationList.forEach((navi: any) => {

                Logger.debug("navigation[" + JSON.stringify(navi) + "]");

                switch (navi.type) {
                    case "navigate":
                        // 通常アクセス
                        break;
                    case "reload":
                        // 更新によるアクセス
                        result = true;
                        break;
                    case "back_forward":
                        // 戻る・進むでのページ移動アクセス
                        break;
                    case "prerender":
                        // linkタグ rel="prerender"での事前アクセス
                        break;
                }
            });
        }

        return result;
    }


    /**
     *  vueオブジェクト生成(PC用)
     */
    private createVueForPc():void {

        let that = this;

        // vueオブジェクト生成
        this._vue = new Vue({
            el: this.ELEMENT_NAME,
            data: {
                FrameId: {
                    val: this.frameId,
                    top: "",
                },
                CanvasHeight: "559px",
                CanvasWidth: "378px",
                OperationHelpUrl: this.operationHelpUrl,
                PrintWarningUrl: this.printWarningUrl,
                UploadPhotoList: this.uploadPhotoList,
                UploadMyStampList: this.uploadMyStampList,
                UploadTegakiStampList: this.uploadTegakiStampList,
                MasterStampList: [],
                HideLabel: EditConst.HIDE_AREA_FADE_OUT,

                // ヘッダーメニュー
                Header: {
                    Logo1Url: this._logo1Url,
                    Logo2Url: this._logo2Url,
                },

                // メニュー活性制御
                ActiveSetPhotoMenu: true,
                ActiveManiPhotoMenu: false,
                ActiveGreetingMenu: false,
                ActiveSenderMenu: false,
                ActiveStampMenu: false,
                ActiveMyStampMenu: false,
                ActiveTegakiStampMenu: false,
                ActiveFinishSelectMenu: false,

                // 赤枠のガイダンスが表示済みかどうか
                ShowedImgGuidance : false,

                // 各種表示制御
                Show: {
                    // フルスクリーンガイダンス
                    FirstGuidance: false,
                    // 中央ペイン ガイダンス
                    BalloonGuidance: true,
                    // 左ペイン
                    PhotoList: false,
                    // 右ペイン あいさつ文入力パネル
                    GreetingPanel: false,
                    // 右ペイン 差出人情報入力パネル
                    SenderPanel: false,
                    // 右ペイン スタンプ選択パネル
                    StampPanel: false,
                    // 手書き色変更パネル（PC版は未使用）
                    TegakiColorPanel: false,
                    // 右ペイン 隠すボタン
                    HiddenButton: false,
                    // 右ペイン 操作メニュー
                    ToolMenu: false,
                    //  右ペイン 操作メニュー ：画像入替・追加
                    SetPhotoMenu: true,
                    //  右ペイン 操作メニュー ：画像編集
                    ManiPhotoMenu: true,
                    //  右ペイン 操作メニュー ：挨拶文編集
                    GreetingMenu: true,
                    //  右ペイン 操作メニュー ：差出人情報編集
                    SenderMenu: true,
                    //  右ペイン 操作メニュー ：スタンプ
                    StampMenu: true,
                    //  右ペイン 操作メニュー ：Myステッカー
                    MyStampMenu: true,
                    //  右ペイン 操作メニュー ：手書きスタンプ
                    TegakiStampMenu: true,

                    //  右ペイン 操作メニュー ：仕上がり選択
                    FinishSelectMenu: false,

                    // 右ペイン オブジェクト操作パネル
                    OparatePallet: false,
                    // 右ペイン オブジェクト操作パネル
                    OparatePalletChangeBright: false,
                    // 右ペイン オブジェクト操作パネル  ：スタンプ削除パレット
                    OparatePalletDelStamp: false,
                    // 右ペイン オブジェクト操作パネル  ：文字色パレット
                    OparatePalletCharColor: false,
                    // 右ペイン オブジェクト操作パネル  ：手書きスタンプ色パレット
                    OparatePalletTegakiColor: false,
                    // 右ペイン オブジェクト操作パネル  ：編集の初期化パレット
                    OparatePalletClear: false,
                    // 右ペイン オブジェクト操作パネル  ：補正しないパレット
                    OparatePalletPhotoCorrect: false,
                    // 右ペイン オブジェクト操作パネル  ：枠ぴったりパレット
                    OparatePalletPitaCorrect: false,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択
                    OparatePalletFinishSelect: true,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択：印刷ボタン
                    OparatePalletFinishSelectPrint: true,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択：銀塩ボタン
                    OparatePalletFinishSelectGinen: true,
                    // 右ペイン オブジェクト操作パネル  ：回転・拡縮・移動
                    OparatePalletTopPart: false,
                    // 右ペイン オブジェクト操作パネル  ：文字色(フチ文字色)カラー
                    ColorPanel: false,
                    //  右ペイン オブジェクト操作パネル  ：カバー(全体)
                    OparatePalletCover: false,
                    //  右ペイン オブジェクト操作パネル  ：カバー(上部)
                    OparatePalletCover4Top: false,
                    //  右ペイン オブジェクト操作パネル  ：カバー(下部)
                    OparatePalletCover4Bottom: false,

                    // 右ペイン あいさつ文例集
                    GreetingDialog: false,
                    // ダイアログエリア
                    DialogArea: false,
                    // メッセージダイアログ
                    MessageDialog: false,
                    // 赤枠の説明文パネル
                    ImgGuidance: true,

                    // キタムラ専用処理判別用フラグ
                    IsKitamura: this._retailerConfig.id === "1" ? true : false,

                    /*
                     * デザインマスタにて表示有無が決まるもの
                     */
                    // [デザイン強制] 右ペイン 操作メニュー　：画像補正するしない
                    PhotoI2AsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：挨拶文編集
                    GreetingMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：スタンプ
                    StampMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：Myステッカー
                    MyStampMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：手書きスタンプ
                    TegakiStampMenuAsDsn: true,

                    // 操作方法の表示(空の場合は表示しない)
                    OperationInfo: this._retailerConfig.operationInfo.edit ? true : false,

                    // 保存ボタンの表示制御(1枚無料は表示させない)
                    SaveButton: false,

                    // 明るさ調整用
                    OparatePalletBrightCover: false,

                    // 自動補正
                    IsImageAutoFilter: true,

                    // 枠ぴったり
                    IsImagePita: false,

                    // 写真スタンプ編集中、または手書き編集中
                    IsShowIframePanel: false,
                },


                // 画像選択モード/削除画像選択モード切り替え
                UploadListModeSelect: true,
                // 削除画像選択モード　OKボタン
                EnableUploadListTrashOK: false,
                // 選択した写真スタンプのファイルID
                MystampFileIdSelected: "",
                // 画像補正しないボタンの活性制御
                EnablePhotoCorrect: false,
                EnablePitaCorrect: false,
                PhotoCorrectCaption: EditConst.PHOTO_CORRECT_CAPTION_PC_OFF,
                EnableNextPageBtn: false,
                // 画像の明るさ
                PhotoBright: 0,
                isBrightDownDisabled: false,
                isBrightUpDisabled: false,

                // Myステッカー次回から表示しない
                ConfirmMyStampCheckbox: false,

                // 手書きスタンプ用 次回から表示しない
                ConfirmTegakiStampCheckbox: false,

                // オブジェクト操作パレットの幅操作
                OparatePalletWide: true,

                FinishSelect: {
                    isGinen: true,
                },

                // ダイアログ
                DialogMessage: "",
                DialogYesBtnCaption: "OK",
                DialogNoBtnCaption: "キャンセル",

                // 色定義一覧
                ColorOptions: [],
                // フォント定義一覧
                FontOptions: [],
                // 文字色パレット：選択色
                SelectCharColor: "",
                // フチ文字色パレット：選択色
                SelectOutlineCharColor: "",
                // 手書きスタンプ色パレット：選択色
                SelectTegakiColor: "",

                AlignOptionsY: [
                    { code: "0", label: EditConst.ALIGN_Y_LEFT },
                    { code: "1", label: EditConst.ALIGN_Y_CENTER },
                    { code: "2", label: EditConst.ALIGN_Y_RIGHT },
                ],
                AlignOptionsT: [
                    { code: "0", label: EditConst.ALIGN_T_TOP },
                    { code: "1", label: EditConst.ALIGN_T_MIDDLE },
                    { code: "2", label: EditConst.ALIGN_T_BOTTOM },
                ],
                CharLayoutOptions: [
                    { code: "1", label: EditConst.CHAR_LAYOUT_T },
                    { code: "0", label: EditConst.CHAR_LAYOUT_Y },
                ],
                CharLayoutOptionsEx: [
                    { code: "1", label: EditConst.CHAR_LAYOUT_T },
                    { code: "0", label: EditConst.CHAR_LAYOUT_Y },
                    { code: "2", label: EditConst.CHAR_LAYOUT_CY },
                ],

                // あいさつ文
                GreetingInfo: {
                    FontSample: "",
                    AlignY: EditConst.ALIGN_Y_LEFT,
                    AlignT: EditConst.ALIGN_T_TOP,
                    CharLayout: EditConst.CHAR_LAYOUT_Y,
                    Font: "",
                    FontSize: EditConst.FONT_SIZE_DEFAULT_Y,
                    OutlineFont: false,
                    Text: "",
                    ShowAlignY: true,
                    SampleList: [],
                    UpdBtnEnable: false,
                    DelBtnEnable: false,
                    SampleSelNo: "",
                    fade: {
                        In: false,
                        Out: false,
                    }
                },

                // 差出人
                ContactOptions: [
                    { code: EditConst.CONTACT_TEL_VAL, label: EditConst.CONTACT_TEL_DISP },
                    { code: EditConst.CONTACT_CELLULAR_VAL, label: EditConst.CONTACT_CELLULAR_DISP },
                    { code: EditConst.CONTACT_FAX_VAL, label: EditConst.CONTACT_FAX_DISP },
                    { code: EditConst.CONTACT_TEL_FAX_VAL, label: EditConst.CONTACT_TEL_FAX_DISP },
                ],
                SenderInfo: {
                    IsNormalInput: true,
                    ShowSenderAlignY: true,
                    Setting: {
                        Font: "",
                        FontSample: "",
                        FontSize: EditConst.FONT_SIZE_DEFAULT_Y,
                        CharLayout: EditConst.CHAR_LAYOUT_Y,
                        CharLayoutEx: EditConst.CHAR_LAYOUT_Y,
                        AlignY: EditConst.ALIGN_Y_LEFT,
                        AlignCY: EditConst.ALIGN_Y_CENTER,
                        AlignT: EditConst.ALIGN_T_MIDDLE,
                        OutlineFont: false,
                    },
                    NormalInput: {
                        PersonalUse: true,
                        ZipCode1: "",
                        ZipCode2: "",
                        Address1: "",
                        Address2: "",
                        Address3: "",
                        Company: {
                            Name: "",
                            Department: "",
                            Position: ""
                        },
                        Names: [
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                        ],
                        Contact: [
                            { Type: EditConst.CONTACT_TEL_DISP, Tel1: "", Tel2: "", Tel3: "" },
                            { Type: EditConst.CONTACT_TEL_DISP, Tel1: "", Tel2: "", Tel3: "" },
                        ],
                        Email: {
                            Mail1: "",
                            Mail2: "",
                        },
                    },
                    FreeInput: "",
                    DelBtnEnable: false,
                    fade: {
                        In: false,
                        Out: false,
                    }
                },

                // スタンプ関連
                Stamp: {
                    CategoryOptions: [],
                    Cagegory: "",
                    CagegoryAll: this.STAMP_CATEGORY_ALL,
                    fade: {
                        In: false,
                        Out: false,
                    }
                },

                // Myステッカー関連
                MyStamp: {
                    fade: {
                        In: false,
                        Out: false,
                    }
                },

                // 手書きスタンプ関連
                TegakiStamp: {
                    fade: {
                        In: false,
                        Out: false,
                    }
                },

                // 仕上がり説明
                ReplaceImgGuideBaloon: {
                    top: "0",
                    left: "0",
                },

                ReplaceGuidanceBalloon: {
                    left: "0",
                    top: "0"
                },
                ImgGuidanceMessage: "",

                EnableOnChangeForGreeting: true,
                EnableOnChangeForSender: true

            },
            methods: {
                // ヘッダー＆フッター関連
                btnClickReturnFlow: (event: JQueryEventObject) => {
                    this.btnClickReturnFlow(event);
                },
                btnClickNextFlow: (event: JQueryEventObject) => {
                    this.btnClickNextFlow(event);
                },
                btnClickSave: (event: JQueryEventObject) => {
                    that._saveLogic.btnClickSave(event);
                },
                btnClickOperationHelp: (event: JQueryEventObject) => {
                    this.btnClickOperationHelp(event);
                },
                linkClickPrintWarning: (event: JQueryEventObject) => {
                    this.linkClickPrintWarning(event);
                },
                // ヘッダー
                btnClickReturnTop: (event: JQueryEventObject) => {
                    this.btnClickReturnTop(event);
                },
                btnClickFaq: (event: JQueryEventObject) => {
                    this.btnClickFaq(event);
                },
                btnClickOrderHistory: (event: JQueryEventObject) => {
                    this.btnClickOrderHistory(event);
                },
                // PC用
                btnClickReturnFlowFromGuidance: (event: JQueryEventObject) => {
                    this.btnClickReturnFlowFromGuidance(event);
                },

                // ツールメニュー関連
                btnClickSetPhotoMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.SET_PHOTO);
                    that._photoLogic.btnClickSetPhotoMenu(event);
                },
                btnClickManiPhotoMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.MANI_PHOTO);
                    that._photoLogic.btnClickManiPhotoMenu(event);
                },
                btnClickGreetingMenu: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingMenu(event);
                },
                btnClickSenderMenu: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderMenu(event);
                },
                btnClickStampMenu: (event: JQueryEventObject) => {
                    that._mstStampLogic.btnClickStampMenu(event);
                },
                btnClickMyStampMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.MYSTAMP);
                    that._myStampLogic.btnClickStampMenu(event);
                },
                btnClickTegakiStampMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.FONTGENIC);
                    that._tegakiStampLogic.btnClickStampMenu(event);
                },
                btnClickFinishSelectMenu: (event: JQueryEventObject) => {
                    this.btnClickFinishSelectMenu(event);
                },
                btnClickHideInputArea: (event: JQueryEventObject) => {
                    this.btnClickHideInputArea(event);
                },
                onInputZipCode1: (event: JQueryEventObject) => {
                    that._senderLogic.onInputZipCode1(event);
                },
                onInputZipCode2: (event: JQueryEventObject) => {
                    that._senderLogic.onInputZipCode2(event);
                },
                btnClickSearchZipToAddress: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSearchZipToAddress(event);
                },
                onClickImgGuidance: (event: JQueryEventObject) => {
                    this.btnClickImgGuidance(event);
                },

                // 画像一覧関連
                imgClickUploadPhoto: (event: JQueryEventObject, fileId: string) => {
                    that._photoLogic.imgClickUploadImage(event, fileId);
                },
                imgClickUploadPhotoCover: (event: JQueryEventObject, fileId: string) => {
                    that._photoLogic.imgClickUploadListImageCoverPc(event, fileId);
                },
                onChangeUploadFileObj: (event: JQueryEventObject) => {
                    that._photoLogic.onChangeUploadFileObj(event);
                },
                onDragStartPhoto: (event: DragEvent, fileId: string) => {
                    that._photoLogic.onDragStartPhoto(event, fileId);
                },
                btnClickPhotoListTrash: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickUploadListTrashPc(event);
                },
                btnClickPhotoListTrashOK: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickUploadListTrashOK(event);
                },
                btnClickPhotoListTrashCancel: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickUploadListTrashCancelPc(event);
                },

                // Myステッカー関連
                imgClickUploadMyStamp: (event: JQueryEventObject, fileId: string) => {
                    if (that._vue.$data.UploadListModeSelect) { 
                        that._myStampLogic.imgClickUploadImageForMystampSelectedPc(event, fileId);
                    } else {
                        that._myStampLogic.imgClickUploadImage(event, fileId);
                    }
                },
                imgClickUploadMyStampCover: (event: JQueryEventObject, fileId: string) => {
                    that._myStampLogic.imgClickUploadListImageCoverPc(event, fileId);
                },
                onChangeUploadMyStampObj: (event: JQueryEventObject) => {
                    that._myStampLogic.onChangeUploadFileObj(event);
                },
                btnClickMyStampListTrash: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadListTrashPc(event);
                },
                btnClickMyStampListTrashOK: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadListTrashOK(event);
                },
                btnClickMyStampListTrashCancel: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadListTrashCancelPc(event);
                },
                btnClickUploadMyStamp: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadMyStamp(event);
                },
                btnClickPasteMyStamp: (event: JQueryEventObject) => {
                    that._myStampLogic.imgClickUploadImage(event, this._vue.$data.MystampFileIdSelected);
                    for (let i: number = 0; i < this._vue.$data.UploadMyStampList.length; i++) {
                        this._vue.$data.UploadMyStampList[i].selected = EditConst.IMG_NOSELECT;
                    }
                },
                btnClickMyStampListEdit: (event: JQueryEventObject) => {
                    that._myStampLogic.imgClickUploadImageForMystampEditPc(event, this._vue.$data.MystampFileIdSelected);
                },

                // 手書きスタンプ関連
                imgClickUploadTegakiStamp: (event: JQueryEventObject, fileId: string) => {
                    that._tegakiStampLogic.imgClickUploadImage(event, fileId);
                },
                imgClickUploadTegakiStampCover: (event: JQueryEventObject, fileId: string) => {
                    that._tegakiStampLogic.imgClickUploadListImageCoverPc(event, fileId);
                },
                btnClickTegakiStampListTrash: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadListTrashPc(event);
                },
                btnClickTegakiStampListTrashOK: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadListTrashOK(event);
                },
                btnClickTegakiStampListTrashCancel: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadListTrashCancelPc(event);
                },
                btnClickUploadTegakiStamp: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadTegakiStamp(event);
                },


                // オブジェクト操作パネル関連
                btnClickRotate90: (rotateRight: boolean, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickRotate90(rotateRight, event);
                },
                btnClickRotate1: (rotateRight: boolean, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickRotate1(rotateRight, event);
                },
                btnClickScale: (scaleUp: boolean, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickScale(scaleUp, event);
                },
                btnClickMove: (whichMove: number, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickMove(whichMove, event);
                },
                btnClickChangeBright: (bright: boolean, event: JQueryEventObject) => {
                    that._photoLogic.btnClickChangeBright(bright, event);
                },
                btnClickEditClear: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickEditClear(event);
                },
                btnClickRemovePhoto: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickRemovePhoto(event);
                },
                btnClickPhotoCorrect: (doFilter: boolean, event: JQueryEventObject) => {
                    if (doFilter == this._vue.$data.Show.IsImageAutoFilter) {
                        return;
                    }
                    that._photoLogic.btnClickPhotoCorrect(event);
                },
                btnClickPitaCorrect: (doPita: boolean, event: JQueryEventObject) => {
                    if (doPita == this._vue.$data.Show.IsImagePita) {
                        return;
                    }
                    that._photoLogic.btnClickPitaCorrect(doPita, event);
                },
                btnClickFinishSelect: (doGinen: boolean, event: JQueryEventObject) => {
                    that._photoLogic.btnClickFinishSelect(doGinen, event);
                    this.setImgGuidanceMesage(doGinen);
                },

                // あいさつ文パネル関連
                onChangeGreetingFont: (event: JQueryEventObject) => {
                    that._greetingLogic.onChangeGreetingFont(event);
                },
                onChangeGreetingCharLayout: (event: JQueryEventObject) => {
                    that._greetingLogic.onChangeGreetingCharLayout(event);
                },
                btnClickGreetingSample: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSample(event);
                },
                btnClickGreetingSet: (requesNew: boolean, event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSet(requesNew, event);
                },
                btnClickGreetingDelete: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingDelete(event);
                },
                btnClickGreetingSampleOK: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSampleOK(event);
                },
                btnClickGreetingSampleCancel: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSampleCancel(event);
                },
                imgClickGreetingSample: (no: string) => {
                    that._greetingLogic.imgClickGreetingSample(no);
                },
                btnClickGreetingFontSize: (isPlus: boolean, event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingFontSize(isPlus, event);
                },

                // 差出人パネル関連
                btnClickSenderInputType: (isNormal: boolean, event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderInputType(isNormal, event);
                },
                onChangeSenderFont: (event: JQueryEventObject) => {
                    that._senderLogic.onChangeSenderFont(event);
                },
                onChangeSenderCharLayout: (event: JQueryEventObject) => {
                    that._senderLogic.onChangeSenderCharLayout(event);
                },
                btnClickSenderInputUse: (usePersonal: boolean, event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderInputUse(usePersonal, event);
                },
                btnClickSenderSet: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderSet(event);
                },
                btnClickSenderDelete: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderDelete(event);
                },
                btnClickSenderFontSize: (isPlus: boolean, event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderFontSize(isPlus, event);
                },

                // スタンプ関連
                imgClickStamp: (event: JQueryEventObject, stampId: number) => {
                    that._mstStampLogic.imgClickStamp(event, stampId);
                },
                btnClickStampDelete: (event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickStampDelete(event);
                },
                radioClickTegakiColor: (colorId: string, event: JQueryEventObject) => {
                    that._tegakiStampLogic.radioClickTegakiColorPc(colorId, event);
                },

                // 外字関連
                btnClickGaijiInput: (event: JQueryEventObject) => {
                    that._gaijiLogic.gaijiInput(event);
                },

                // inputフォーカス時のイベント
                // 外字が使えるかチェック。
                onFocusEnableGaiji: (event: JQueryEventObject) => {
                    let selFont = that.editInfo.master.font.find(x => x.name == that._vue.$data.SenderInfo.Setting.Font);
                    that._gaijiLogic.gaijiButtonEnable(event, selFont.gaijiFlg);
                },
            },
            beforeCreate: () => {
                //Logger.log("beforeCreate()");
                // 初期処理
                this.doOnload();
            },
            created: () => {
            },
            beforeMount: () => {
            },
            mounted: () => {
            },
            beforeUpdate: () => {
            },
            updated: () => {

                // 初期化直後のキャンバスサイズ調整
                if (this.loadComplited) {
                    this.loadComplited = false;
                    this.allowResizeFunc = true;
                    // 初回の単発呼び出し
                    this.resizeWindowHandler(this);
                    // リテーラ別のチャットボット制御
                    var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
                    if (divChatBot) {
                        divChatBot.style.display = this._retailerConfig.id == "0" ? "block" : "none";
                    }
                }
            },
            beforeDestroy: () => {
            },
            destroyed: () => {
            },
            computed: {
                ActiveUploadPhotoList: function () {
                    return this.UploadPhotoList.filter(p => p.deleteFlg === false);
                },
                CategoryStampList: function () {
                    if (this.Stamp.Cagegory === this.Stamp.CagegoryAll) {
                        return this.MasterStampList;
                    }
                    else {
                        return this.MasterStampList.filter(s => s.category === this.Stamp.Cagegory);
                    }
                },
                ActiveUploadMyStampList: function () {
                    return this.UploadMyStampList.filter(p => p.deleteFlg === false);
                },
                ActiveUploadTegakiStampList: function () {
                    return this.UploadTegakiStampList.filter(p => p.deleteFlg === false);
                },
                IsMystampSelected: function () {
                    return util.relic.listFind(this.UploadMyStampList, (p: uploadPhoto) => {
                        return p.selected === EditConst.IMG_SELECTED;
                    });
                },
            },
            watch: {
                'Show.IsShowIframePanel': function (newVal, oldVal) {
                    var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
                    if (divChatBot) {
                        if (newVal) {
                            divChatBot.style.display = "none";
                        } else {
                            divChatBot.style.display = that._retailerConfig.id == "0" ? "block" : "none";
                        }
                    }
                }
            }
        });

    }

    /**
     *  vueオブジェクト生成(SP用)
     */
    private createVueForSp(): void {

        let that = this;

        // vueオブジェクト生成
        this._vue = new Vue({
            el: this.ELEMENT_NAME,
            data: {
                // ヘッダー関連
                // sp
                Header: {
                    Title: "はがきの編集"
                },

                ReplaceGaijiShortCut: {
                    top: "0",
                    left: "0",
                },
                FocusGaijiShortCut: "",
                // ガイダンス関連
                Guidance: {

                },
                ReplaceImgGuideBaloon: {
                    top: "0",
                    left: "0",
                },
                // 赤枠のガイダンスが表示済みかどうか
                ShowedImgGuidance: false,
                ImgGuidanceMessage:"",
                UploadPhotoList: this.uploadPhotoList,
                UploadMyStampList: this.uploadMyStampList,
                UploadTegakiStampList: this.uploadTegakiStampList,
                MasterStampList: [],

                // 各種表示制御
                Show: {
                    // フルスクリーンガイダンス1
                    Guidance1: false,
                    // フルスクリーンガイダンス2
                    Guidance2: false,
                    // フルスクリーンガイダンス3
                    Guidance3: false,
                    // フルスクリーンガイダンス4
                    Guidance4: false,
                    // フルスクリーンガイダンス5
                    Guidance5: false,
                    // フルスクリーンロック
                    ScreenLock: false,
                    /// 左ペイン
                    PhotoList: false,

                    // sp
                    /// 編集エリア
                    EditArea: true,
                    // sp
                    // 画像削除ボタン
                    PhotoDeleteBtn: false,
                    // sp
                    // Myステッカー削除ボタン
                    MyStampListTrashBtn: false,
                    // sp
                    // 手書きスタンプ削除ボタン（アップロード一覧から削除するボタン）
                    TegakiStampListTrashBtn: false,
                    // sp
                    // あいさつ文削除ボタン
                    GreetingDeleteBtn: false,
                    // あいさつ文更新ボタン
                    GreetingUpdataBtn: false,
                    // sp
                    // 差出人削除ボタン
                    SenderDeleteBtn: false,
                    // sp
                    // スタンプ削除ボタン
                    StampDeleteBtn: false,
                    // sp
                    // 決定ボタン(ホームへ)
                    CommitNextHomeBtn: false,
                    
                    // sp
                    // デザイン選択に戻る
                    ReturnFlowBtn: true,
                    // sp
                    // 編集画面のホームに戻る(モード変更なし)
                    ReturnHomeBtn: false,
                    // sp
                    // 編集画面のホームに戻る(モード変更あり)
                    ReturnHomeExBtn: false,
                    // 編集画面のホームに戻る(モード変更なし－入替操作解除)
                    ReturnHomeFromSwapItemBtn: false,
                    // 画像の位置調整画面に戻る
                    ReturnPhotoManiBtn: false,
                    // あいさつ文の位置調整画面に戻る
                    ReturnGreetingHomeBtn: false,
                    // 差出人の位置調整画面に戻る
                    ReturnSenderHomeBtn: false,
                    // スタンプの位置調整画面に戻る
                    ReturnStampHomeBtn: false,
                    // Myステッカーの位置調整画面に戻る
                    ReturnMyStampHomeBtn: false,
                    // 手書きスタンプの位置調整画面に戻る
                    ReturnTegakiStampHomeBtn: false,

                    // sp
                    // 次へ(プレビュー画面へ)
                    NextFlowBtn: true,
                    // sp
                    // (画像一覧から)次へ
                    NextHomeFromImgListBtn: false,
                    // sp
                    // (Myステッカー一覧から)次へ
                    NextHomeFromMyStampListBtn: false,
                    // sp
                    // (手書きスタンプ一覧から)次へ
                    NextHomeFromTegakiStampListBtn: false,
                    // sp
                    // フッターメニュー
                    FooterMenu: true,
                    // sp
                    // メッセージエリア
                    MessageArea: false,
                    // sp
                    SenderGaijiMenu: false,
                    
                    // 右ペイン あいさつ文入力パネル
                    GreetingPanel: false,
                    // 右ペイン 差出人情報入力パネル
                    SenderPanel: false,
                    // 右ペイン スタンプ選択パネル
                    StampPanel: false,
                    // 手書き色変更パネル（SP版のみ）
                    TegakiColorPanel: false,
                    // 右ペイン 隠すボタン
                    HiddenButton: false,
                    // 右ペイン 操作メニュー
                    ToolMenu: false,
                    //  右ペイン 操作メニュー ：画像入替・追加
                    SetPhotoMenu: true,
                    ////  右ペイン 操作メニュー ：画像編集
                    //ManiPhotoMenu: true,
                    //  右ペイン 操作メニュー ：挨拶文編集
                    GreetingMenu: true,
                    //  右ペイン 操作メニュー ：差出人情報編集
                    SenderMenu: true,
                    //  右ペイン 操作メニュー ：スタンプ
                    StampMenu: true,
                    //  右ペイン 操作メニュー ：Myステッカー
                    MyStampMenu: true,
                    //  右ペイン 操作メニュー ：手書きスタンプ
                    TegakiStampMenu: true,
                    //  右ペイン 操作メニュー ：仕上がり選択
                    FinishSelectMenu: false,

                    // SP
                    //  画像選択時の操作メニュー
                    EditImageMenu: false,
                    // SP
                    // 画像操作の入替メニュー
                    SwapItemMenu: true,

                    // 右ペイン オブジェクト操作パネル
                    OparatePallet: false,
                    // 右ペイン オブジェクト操作パネル  ：明るさ調整パネル
                    OparatePalletChangeBright: false,
                    // 右ペイン オブジェクト操作パネル  ：スタンプ削除パレット
                    OparatePalletDelStamp: false,
                    // 右ペイン オブジェクト操作パネル  ：文字色パレット
                    OparatePalletCharColor: false,
                    // 右ペイン オブジェクト操作パネル  ：手書きスタンプ色パレット
                    OparatePalletTegakiColor: false,
                    // 右ペイン オブジェクト操作パネル  ：編集の初期化パレット
                    OparatePalletClear: false,
                    // 右ペイン オブジェクト操作パネル  ：補正しないパレット
                    OparatePalletPhotoCorrect: false,
                    // 右ペイン オブジェクト操作パネル  ：枠ぴったりパレット
                    OparatePalletPitaCorrect: false,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択
                    OparatePalletFinishSelect: true,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択：印刷ボタン
                    OparatePalletFinishSelectPrint: true,
                    // 右ペイン オブジェクト操作パネル  ：仕上がり選択：銀塩ボタン
                    OparatePalletFinishSelectGinen: true,
                    // 右ペイン オブジェクト操作パネル  ：回転・拡縮・移動
                    OparatePalletTopPart: false,
                    // 右ペイン オブジェクト操作パネル  ：文字色(フチ文字色)カラー
                    ColorPanel: false,
                    ////  右ペイン オブジェクト操作パネル  ：カバー(全体)
                    OparatePalletCover: false,
                    ////  右ペイン オブジェクト操作パネル  ：カバー(上部)
                    //OparatePalletCover4Top: false,
                    ////  右ペイン オブジェクト操作パネル  ：カバー(下部)
                    //OparatePalletCover4Bottom: false,

                    OparatePalletBrightCover: false,

                    // 自動補正
                    IsImageAutoFilter: true,

                    // 枠ぴったり
                    IsImagePita: false,

                    // SP
                    //  右ペイン オブジェクト操作パネル  ：アイテム追加(あいさつ文)
                    OparatePalletAddGreetingItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム追加(差出人)
                    //OparatePalletAddSenderItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム追加(スタンプ)
                    OparatePalletAddStampItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム追加(Myステッカー)
                    OparatePalletAddMyStampItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム追加(手書きスタンプ)
                    OparatePalletAddTegakiStampItem: false,
                    //  手書き色変更（SPモードのみ）
                    OparatePalletChangeTegakiStampColor: false,

                    //  右ペイン オブジェクト操作パネル  ：アイテム削除
                    //OparatePalletDelItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム編集(あいさつ文)
                    OparatePalletEditGreetingItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム編集(差出人)
                    OparatePalletEditSenderItem: false,
                    //  右ペイン オブジェクト操作パネル  ：アイテム編集(スタンプ)
                    //OparatePalletEditStampItem: false,

                    // 右ペイン あいさつ文例集
                    GreetingDialog: false,
                    // ダイアログエリア
                    DialogArea: false,
                    // メッセージダイアログ
                    //MessageDialog: false,
                    // 赤枠の説明文パネル
                    ImgGuidance: true,

                    // SP
                    StampCategoryList: false,

                    // キタムラ専用処理判別用フラグ
                    IsKitamura: this._retailerConfig.id === "1" ? true : false,

                    /*
                     * デザインマスタにて表示有無が決まるもの
                     */
                    // [デザイン強制] 右ペイン 操作メニュー　：画像補正するしない
                    PhotoI2AsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：挨拶文編集
                    GreetingMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：スタンプ
                    StampMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：Myステッカー
                    MyStampMenuAsDsn: true,
                    // [デザイン強制] 右ペイン 操作メニュー　：手書きスタンプ
                    TegakiStampMenuAsDsn: true,

                    // 保存ボタンの表示制御(1枚無料は表示させない)
                    SaveButton: false,

                    // 外字のショートカット
                    GaijiShortCutBtn: false,

                    // 画像自動補正表示
                    EditImageFilterMenu: false,

                    // 画像枠ぴったり表示
                    EditImagePitaMenu: false,

                    // 仕上げ選択表示
                    FinishSelectMenuDialog: false,

                    // 仕上げ選択アイコン表示
                    FinishSelectMenuIcon: false,

                    // メニューの矢印ホバー制御
                    ScrollList: {
                        menuList: { id: "menuList", isMenuScrollLeftDisabled: true, isMenuScrollRightDisabled: false, isBtnHidden: true },
                        imgMenuList: { id: "imgMenuList", isMenuScrollLeftDisabled: true, isMenuScrollRightDisabled: false, isBtnHidden: true },
                        adjustMenuList: { id: "adjustMenuList", isMenuScrollLeftDisabled: true, isMenuScrollRightDisabled: false, isBtnHidden: true },
                    },

                    // タイトル表示制御
                    TitleMain: EditConst.TITLE_MAIN,
                },

                // 削除画像選択モード　OKボタン
                EnableUploadListTrashOK: false,
                PhotoCorrectCaption: EditConst.PHOTO_CORRECT_CAPTION_SP_OFF,
                EnableNextPageBtn: false,

                // Myステッカー次回から表示しない
                ConfirmMyStampCheckbox: false,
                // 手書きスタンプ次回から表示しない
                ConfirmTegakiStampCheckbox: false,

                FinishSelect: {
                    isGinen: true,
                },

                // 色定義一覧
                ColorOptions: [],
                // フォント定義一覧
                FontOptions: [],
                // 文字色パレット：選択色
                SelectCharColor: "",
                // フチ文字色パレット：選択色
                SelectOutlineCharColor: "",
                // 手書きスタンプ色パレット：選択色
                SelectTegakiColor: "",
                SelectTegakiColorSPEdit: "",

                AlignOptionsY: [
                    { code: "0", label: EditConst.ALIGN_Y_LEFT },
                    { code: "1", label: EditConst.ALIGN_Y_CENTER },
                    { code: "2", label: EditConst.ALIGN_Y_RIGHT },
                ],
                AlignOptionsT: [
                    { code: "0", label: EditConst.ALIGN_T_TOP },
                    { code: "1", label: EditConst.ALIGN_T_MIDDLE },
                    { code: "2", label: EditConst.ALIGN_T_BOTTOM },
                ],
                CharLayoutOptions: [
                    { code: "1", label: EditConst.CHAR_LAYOUT_T },
                    { code: "0", label: EditConst.CHAR_LAYOUT_Y },
                ],
                CharLayoutOptionsEx: [
                    { code: "1", label: EditConst.CHAR_LAYOUT_T },
                    { code: "0", label: EditConst.CHAR_LAYOUT_Y },
                    { code: "2", label: EditConst.CHAR_LAYOUT_CY },
                ],

                // あいさつ文
                GreetingInfo: {
                    FontSample: "",
                    AlignY: EditConst.ALIGN_Y_LEFT,
                    AlignT: EditConst.ALIGN_T_TOP,
                    CharLayout: EditConst.CHAR_LAYOUT_Y,
                    Font: "",
                    FontSize: EditConst.FONT_SIZE_DEFAULT_Y,
                    OutlineFont: false,
                    Text: "",
                    ShowAlignY: true,
                    SampleList: [],
                    UpdBtnEnable: false,
                    DelBtnEnable: false,
                    SampleSelNo: "",
                },

                // 差出人
                ContactOptions: [
                    { code: EditConst.CONTACT_TEL_VAL, label: EditConst.CONTACT_TEL_DISP },
                    { code: EditConst.CONTACT_CELLULAR_VAL, label: EditConst.CONTACT_CELLULAR_DISP },
                    { code: EditConst.CONTACT_FAX_VAL, label: EditConst.CONTACT_FAX_DISP },
                    { code: EditConst.CONTACT_TEL_FAX_VAL, label: EditConst.CONTACT_TEL_FAX_DISP },
                ],
                // Sp
                FormatOptions: [
                    { code: EditConst.SENDER_TYPE_PORSONAL, label: EditConst.SENDER_TYPE_PORSONAL_STR },
                    { code: EditConst.SENDER_TYPE_CORP, label: EditConst.SENDER_TYPE_CORP_STR },
                    { code: EditConst.SENDER_TYPE_FREE, label: EditConst.SENDER_TYPE_FREE_STR },
                ],
                SenderInfo: {
                    IsNormalInput: true,
                    ShowSenderAlignY: true,
                    Setting: {
                        Font: "",
                        FontSample: "",
                        FontSize: EditConst.FONT_SIZE_DEFAULT_Y,
                        CharLayout: EditConst.CHAR_LAYOUT_Y,
                        CharLayoutEx: EditConst.CHAR_LAYOUT_Y,
                        AlignY: EditConst.ALIGN_Y_LEFT,
                        AlignCY: EditConst.ALIGN_Y_CENTER,
                        AlignT: EditConst.ALIGN_T_MIDDLE,
                        OutlineFont: false,
                        // SP
                        Format: EditConst.SENDER_TYPE_PORSONAL_STR,
                    },
                    NormalInput: {
                        PersonalUse: true,
                        ZipCode1: "",
                        ZipCode2: "",
                        Address1: "",
                        Address2: "",
                        Address3: "",
                        Company: {
                            Name: "",
                            Department: "",
                            Position: ""
                        },
                        Names: [
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                            { LastName: "", FirstName: "", LastNameKana: "", FirstNameKana: "", PS: "" },
                        ],
                        Contact: [
                            { Type: EditConst.CONTACT_TEL_DISP, Tel1: "", Tel2: "", Tel3: "" },
                            { Type: EditConst.CONTACT_TEL_DISP, Tel1: "", Tel2: "", Tel3: "" },
                        ],
                        Email: {
                            Mail1: "",
                            Mail2: "",
                        },
                    },
                    FreeInput: "",
                    DelBtnEnable: false,
                },

                // スタンプ関連
                Stamp: {
                    CategoryOptions: [],
                    Cagegory: "",
                    CagegoryAll: this.STAMP_CATEGORY_ALL,
                    DelBtnEnable: false,
                    TargetStamp: "",
                },

                // Myステッカー関連
                MyStamp: {
                    TargetStamp: "",
                },

                // 手書きスタンプ関連
                TegakiStamp: {
                    TargetStamp: "",
                },


                EnableOnChangeForGreeting: true,
                EnableOnChangeForSender: true,

                // SP
                // 画像入替関連
                SwatpItem: {
                    doSwap: false,
                    FromItem: "",
                    ToItem: "",
                },

                // SP
                // 解像度低の場合の考慮
                ShortSize: false,
                // タッチイベント制御
                AllowTouchEvent: true,

                // 画像の明るさ
                PhotoBright: 0,
                isBrightDownDisabled: false,
                isBrightUpDisabled: false,
            },
            methods: {
                // ヘッダー＆フッター関連
                btnClickReturnFlow: (event: JQueryEventObject) => {
                    this.btnClickReturnFlow(event);
                },
                btnClickNextFlow: (event: JQueryEventObject) => {
                    this.btnClickNextFlow(event);
                },
                btnClickSave: (event: JQueryEventObject) => {
                    that._saveLogic.btnClickSave(event);
                },
                // sp
                btnClickReturnHome: (doSetMode: boolean, doCommit: boolean, event: JQueryEventObject) => {
                    if (that.editMode === EDIT_MODE_KIND.SET_PHOTO) {
                        //画像枠クリックによる一覧表示は、edit_sonbp_if.js内で完結のためVue側で検知できないため、ここで削除選択をクリアする。
                        that.reqDelAllclear(EDIT_MODE_KIND.SET_PHOTO);
                    }
                    this.btnClickReturnHome(doSetMode, doCommit, event);
                },
                // sp
                returnPhotoManiBtn: (event: JQueryEventObject) => {
                    that._photoLogic.returnPhotoManiBtn(event);
                },
                // sp
                returnGreetingHomeBtn: (event: JQueryEventObject) => {
                    that._greetingLogic.returnGreetingHomeBtn(event);
                },
                // sp
                returnSenderHomeBtn: (event: JQueryEventObject) => {
                    that._senderLogic.returnSenderHomeBtn(event);
                },
                // sp
                returnStampHomeBtn: (event: JQueryEventObject) => {
                    that._mstStampLogic.returnStampHomeBtn(event);
                },
                // sp
                returnMyStampHomeBtn: (event: JQueryEventObject) => {
                    this.btnClickReturnHome(true, true, event);
                },
                // sp
                returnTegakiStampHomeBtn: (event: JQueryEventObject) => {
                    if (this._vue.$data.Show.TegakiColorPanel)
                        that._tegakiStampLogic.returnStampHomeBtn(event)
                    else
                        this.btnClickReturnHome(true, true, event);
                },


                // ガイダンス関連
                // sp
                btnClickCloseGuidance1: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance1(event);
                },
                // sp
                btnClickCloseGuidance2: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance2(event);
                },
                btnClickGuidance2Prev: (event: JQueryEventObject) => {
                    this.btnClickGuidance2Prev(event);
                },
                // sp
                btnClickCloseGuidance3: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance3(event);
                },
                btnClickGuidance3Prev: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance1(event, true);
                },
                // sp
                btnClickCloseGuidance4: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance4(event);
                },
                btnClickGuidance4Prev: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance2(event, true);
                },
                // sp
                btnClickCloseGuidance5: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance5(event);
                },
                btnClickGuidance5Prev: (event: JQueryEventObject) => {
                    this.btnClickCloseGuidance3(event, true);
                },

                // ツールメニュー関連
                btnClickSetPhotoMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.SET_PHOTO);
                    that._photoLogic.btnClickSetPhotoMenu(event);
                },
                btnClickManiPhotoMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.MANI_PHOTO);
                    that._photoLogic.btnClickManiPhotoMenu(event);
                },
                btnClickGreetingMenu: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingMenu(event);
                },
                btnClickSenderMenu: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderMenu(event);
                },
                btnClickStampMenu: (event: JQueryEventObject) => {
                    that._mstStampLogic.btnClickStampMenu(event);
                },
                btnClickMyStampMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.MYSTAMP);
                    that._myStampLogic.btnClickStampMenu(event);
                },
                btnClickTegakiStampMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.FONTGENIC);
                    that._tegakiStampLogic.btnClickStampMenu(event);
                },
                btnClickFinishSelectMenu: (event: JQueryEventObject) => {
                    this.btnClickFinishSelectMenu(event);
                    const isGinen = this._vue.$data.FinishSelect.isGinen as boolean;
                    this.setImgGuidanceMesage(isGinen);
                },
                // sp
                btnClickReturnMainMenu: (event: JQueryEventObject) => {
                    this.btnClickReturnMainMenu(event);
                },
                // sp
                btnClickImageListMenu: (event: JQueryEventObject) => {
                    that.reqDelAllclear(EDIT_MODE_KIND.SET_PHOTO);
                    that._photoLogic.btnClickImageListMenu(event);
                },
                // sp
                btnClickSwapItemMenu: (doStwapStart: boolean, event: JQueryEventObject) => {
                    that._photoLogic.btnClickSwapItemMenu(doStwapStart, event);
                },
                // 明るさ調整
                btnClickManiChangeBright: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickManiChangeBright(event);
                },
                btnClickChangeBright: (bright: boolean, event: JQueryEventObject) => {
                    that._photoLogic.btnClickChangeBright(bright, event);
                },

                // 画像一覧関連
                imgClickUploadPhoto: (event: JQueryEventObject, fileId: string) => {
                    that._photoLogic.imgClickUploadImage(event, fileId);
                },
                onChangeUploadFileObj: (event: JQueryEventObject) => {
                    that._photoLogic.onChangeUploadFileObj(event);
                },
                btnClickPhotoListTrashOK: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickUploadListTrashOK(event);
                },
                // sp
                btnClickNextHomeFromImgList: (event: JQueryEventObject, fileId: string) => {
                    that._photoLogic.btnClickNextFromUploadImageListSp(event);
                },
                // sp
                btnClickNextHomeFromMyStampList: (event: JQueryEventObject, fileId: string) => {
                    that._myStampLogic.btnClickNextFromUploadImageListSp(event);
                },
                // sp
                btnClickNextHomeFromTegakiStampList: (event: JQueryEventObject, fileId: string) => {
                    that._tegakiStampLogic.btnClickNextFromUploadImageListSp(event);
                },
                // sp
                btnClickNextHomeFromTegakiColorPanel: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickNextHomeFromTegakiColorPanelSp(event);
                },

                // オブジェクト操作パネル関連
                btnClickRotate90: (rotateRight: boolean, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickRotate90(rotateRight, event);
                },
                btnSetPitaCorrect: (doPita: boolean, event: JQueryEventObject) => {
                    if (doPita == this._vue.$data.Show.IsImagePita) {
                        return;
                    }
                    that._photoLogic.btnClickPitaCorrect(doPita, event);
                },
                // sp
                btnClickEditImagePitaMenu: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickEditImagePitaMenu(event);
                },
                btnClickScale: (scaleUp: boolean, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickScale(scaleUp, event);
                },
                btnClickMove: (whichMove: number, event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickMove(whichMove, event);
                },
                btnClickRemovePhoto: (event: JQueryEventObject) => {
                    that._photoLogic.btnClickRemovePhoto(event);
                },
                btnSetPhotoCorrect: (doFilter: boolean, event: JQueryEventObject) => {
                    if (doFilter == this._vue.$data.Show.IsImageAutoFilter) {
                        return;
                    }
                    that._photoLogic.btnClickPhotoCorrect(event);
                },
                btnSetFinishSelectCorrect: (doGinen: boolean, event: JQueryEventObject) => {
                    that._photoLogic.btnClickFinishSelect(doGinen, event);
                    const isGinen = this._vue.$data.FinishSelect.isGinen as boolean;
                    this.setImgGuidanceMesage(isGinen);
                },
                // SP
                btnClickEditGreetingItem: (doAdd: boolean, event: JQueryEventObject) => {
                    that._greetingLogic.btnClickEditGreetingItem(doAdd, event);
                },
                // SP
                btnClickEditSenderItem: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickEditSenderItem(event);
                },
                // SP
                btnClickEditStampItem: (event: JQueryEventObject) => {
                    that._mstStampLogic.btnClickEditStampItem(event);
                },
                // SP
                btnClickEditMyStampItem: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickEditStampItem(event);
                },
                // SP
                btnClickEditTegakiStampItem: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickEditStampItem(event);
                },
                // SP
                btnClickChangeTegakiStampColor: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickChangeTegakiStampColorSp(event);
                },
                btnClickMenuScroll: (id: string, i: number) => {
                    var moveWidth = $(window).width() > 600 ? 100 : 50;
                    if (document.getElementById(id).children.length >= 3) {
                        moveWidth = document.getElementById(id).children[1].clientWidth;
                    }
                    document.getElementById(id).scrollLeft += moveWidth * i;
                    this.setScrollMenuList(id);
                },

                // あいさつ文パネル関連
                onChangeGreetingFont: (event: JQueryEventObject) => {
                    that._greetingLogic.onChangeGreetingFont(event);
                },
                onChangeGreetingCharLayout: (event: JQueryEventObject) => {
                    that._greetingLogic.onChangeGreetingCharLayout(event);
                },
                btnClickGreetingSample: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSample(event);
                },
                btnClickGreetingSet: (requesNew: boolean, event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSet(requesNew, event);
                },
                btnClickGreetingDelete: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingDelete(event);
                },
                btnClickGreetingSampleOK: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSampleOK(event);
                },
                btnClickGreetingSampleCancel: (event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingSampleCancel(event);
                },
                imgClickGreetingSample: (no: string) => {
                    that._greetingLogic.imgClickGreetingSample(no);
                },
                btnClickGreetingFontSize: (isPlus: boolean, event: JQueryEventObject) => {
                    that._greetingLogic.btnClickGreetingFontSize(isPlus, event);
                },

                // 差出人パネル関連
                onChangeSenderFont: (event: JQueryEventObject) => {
                    that._senderLogic.onChangeSenderFont(event);
                },
                onChangeSenderCharLayout: (event: JQueryEventObject) => {
                    that._senderLogic.onChangeSenderCharLayout(event);
                },
                btnClickSenderSet: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderSet(event);
                },
                btnClickSenderDelete: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderDelete(event);
                },
                btnClickSenderFontSize: (isPlus: boolean, event: JQueryEventObject) => {
                    that._senderLogic.btnClickSenderFontSize(isPlus, event);
                },
                // SP
                onChangeSenderFormat: (event: JQueryEventObject) => {
                    that._senderLogic.onChangeSenderFormat(event);
                },

                // スタンプ関連
                imgClickStamp: (event: JQueryEventObject, stampId: number) => {
                    that._mstStampLogic.imgClickStamp(event, stampId);
                },
                btnClickStampDelete: (event: JQueryEventObject) => {
                    that._objectManiLogic.btnClickStampDelete(event);
                },
                // SP
                btnClickStampSet: (event: JQueryEventObject) => {
                    that._mstStampLogic.btnClickStampSet(event);
                },
                // SP
                cmbClickStampCategory: (event: JQueryEventObject) => {
                    that._mstStampLogic.cmbClickStampCategory(event);
                },
                // SP
                imgClickStampCategory: (event: JQueryEventObject) => {
                    that._mstStampLogic.imgClickStampCategory(event);
                },
                // Sp
                imgClickStampForSp: (event: JQueryEventObject, stampId: number) => {
                    that._mstStampLogic.imgClickStampForSp(event, stampId);
                },

                // Myステッカー関連
                imgClickUploadMyStamp: (event: JQueryEventObject, fileId: string) => {
                    that._myStampLogic.imgClickUploadImage(event, fileId);
                },
                onChangeUploadMyStampObj: (event: JQueryEventObject) => {
                    that._myStampLogic.onChangeUploadFileObj(event);
                },
                btnClickMyStampListTrashOK: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadListTrashOK(event);
                },
                btnClickUploadMyStamp: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickUploadMyStamp(event);
                },
                // SP
                btnClickMyStampEditSp: (event: JQueryEventObject) => {
                    that._myStampLogic.btnClickMyStampEditSp(event);
                },

                // 手書きスタンプ関連
                imgClickUploadTegakiStamp: (event: JQueryEventObject, fileId: string) => {
                    that._tegakiStampLogic.imgClickUploadImage(event, fileId);
                },
                btnClickTegakiStampListTrashOK: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadListTrashOK(event);
                },
                btnClickUploadTegakiStamp: (event: JQueryEventObject) => {
                    that._tegakiStampLogic.btnClickUploadTegakiStamp(event);
                },

                // 外字関連
                btnClickGaijiInput: (event: JQueryEventObject) => {
                    that._gaijiLogic.gaijiInput(event);
                },

                // inputフォーカス時のイベント
                // 外字が使えるかチェック。
                onFocusEnableGaiji: (event: JQueryEventObject) => {
                    let selFont = that.editInfo.master.font.find(x => x.name == that._vue.$data.SenderInfo.Setting.Font);
                    that._gaijiLogic.gaijiButtonEnable(event, selFont.gaijiFlg);
                },
                // 郵便番号の入力
                onInputZipCode1: (event: JQueryEventObject) => {
                    that._senderLogic.onInputZipCode1(event);
                },
                onInputZipCode2: (event: JQueryEventObject)=>{
                    that._senderLogic.onInputZipCode2(event);
                },
                //住所検索(SP版)
                btnClickSearchZipToAddress: (event: JQueryEventObject) => {
                    that._senderLogic.btnClickSearchZipToAddress(event);
                },
                onClickImgGuidance: (event: JQueryEventObject) => {
                    this.btnClickImgGuidance(event);
                },
                scrollMenu: (id: string) => {
                    this.setScrollMenuList(id);
                },
            },
            beforeCreate: () => {
                //Logger.log("beforeCreate()");
                // 初期処理
                this.doOnload();
            },
            created: () => {
            },
            beforeMount: () => {
            },
            mounted: () => {
            },
            beforeUpdate: () => {
            },
            updated: () => {

                // 初期化直後のキャンバスサイズ調整
                if (this.loadComplited) {
                    this.loadComplited = false;
                    this.allowResizeFunc = true;
                    // 初回の単発呼び出し
                    this.resizeWindowHandler(this);
                    // リテーラ別のチャットボット制御
                    var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
                    if (divChatBot) {
                        divChatBot.style.display = this._retailerConfig.id == "0" && this._vue.$data.Header.Title == EditConst.TITLE_MAIN ? "block" : "none";
                    }
                }
                this.resizeWindowHandlerForScrollMenu(this);
            },
            beforeDestroy: () => {
            },
            destroyed: () => {
            },
            computed: {
                ActiveUploadPhotoList: function () {
                    return this.UploadPhotoList.filter(p => p.deleteFlg === false);
                },
                CategoryStampList: function () {
                    if (this.Stamp.Cagegory === this.Stamp.CagegoryAll) {
                        return this.MasterStampList;
                    }
                    else {
                        return this.MasterStampList.filter(s => s.category === this.Stamp.Cagegory);
                    }
                },
                ActiveUploadMyStampList: function () {
                    return this.UploadMyStampList.filter(p => p.deleteFlg === false);
                },
                ActiveUploadTegakiStampList: function () {
                    return this.UploadTegakiStampList.filter(p => p.deleteFlg === false);
                },
                ShowMenuDialogNextFlow: function () {
                    return this.$data.Show.EditImageFilterMenu || this.$data.Show.EditImagePitaMenu || (this.$data.Show.FinishSelectMenuDialog && this.$data.Header.Title == EditConst.TITLE_MAIN);
                },
            },
            watch: {
                'Header.Title': function (newVal, oldVal) {
                    var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
                    if (divChatBot) {
                        if (newVal != EditConst.TITLE_MAIN &&
                            newVal != EditConst.TITLE_MANIPHOTO &&
                            newVal != EditConst.TITLE_STAMP &&
                            newVal != EditConst.TITLE_MYSTAMP &&
                            newVal != EditConst.TITLE_GREETING &&
                            newVal != EditConst.TITLE_SENDER &&
                            newVal != EditConst.TITLE_TEGAKISTAMP
                        ) {
                            divChatBot.style.display = "none";
                        } else {
                            divChatBot.style.display = that._retailerConfig.id == "0" ? "block" : "none";
                        }
                    }
                }
            }
        });
    }

    /**
     * リテーラ別の初期化処理
     */
    public initRetailer(): void {
        // リテーラロゴURL設定
        this._logo1Url = this._retailerConfig.logo1;
        this._logo2Url = this._retailerConfig.logo2;
    }

    /**
     * ウィンドウのリサイズイベントハンドラ登録
     */
    public resizeWindowInit(): void {
        // SPでは初回しか実行させない
        // 画面サイズが変わることはない
        //（キーボード表示によってイベント発火させたくないため）
        if (!ui.usePcDesign()) {
            return;
        }

        let that: editController = this;
        let f = function () {
            that.resizeWindowHandler(that);
            that.resizeWindowHandlerForScrollMenu(that);
        };
        window.removeEventListener('resize', f);
        window.addEventListener('resize', f);
    }
    /**
     * ウィンドウのリサイズイベントハンドラ(メニューバー変更用)
     */
    public resizeWindowHandlerForScrollMenu(contoroller: editController): void {
        if (contoroller._usePcDesign) {
            return;
        }
        // メニューの矢印ホバー制御
        ["menuList", "imgMenuList", "adjustMenuList"].forEach(id => {
            this.setScrollMenuList(id);
        });
    }

    /**
     * ウィンドウのリサイズイベントハンドラ
     * @param contoroller   : editMainController
     */
    public resizeWindowHandler(contoroller: editController): void {

        if (!contoroller.allowResizeFunc) {
            Logger.debug("resizeWindowHandler()  not allow func yet. [" + contoroller.allowResizeFunc + "]");
            return;
        }

        if (contoroller._usePcDesign) {
            // PCの場合

            // ページエリアサイズ算出
            const pageSize = contoroller.calcSonbpPageAreaSize();
            const setPageSize: number = pageSize.height;

            // sonbpへ通知
            contoroller.sonbpIfController.resizeContents(setPageSize);

            // ハガキの比率(横/縦) 長辺から短辺を求める用
            const ratio: number = 1.04 / 1.48;
            // 編集エリアの幅
            const editAreaWidth: number = $("#editArea").width();

            if (contoroller.sonbpIfController.PdfPageSizeHeight < contoroller.sonbpIfController.PdfPageSizeWidth) {
                // 横長テンプレートの場合

                // タイプ記号の位置調整
                {
                    // ページサイズ(長辺)から、ハガキの高さ算出
                    const hagakiHeight: number = setPageSize * ratio;
                    // ページサイズ(長辺) - ハガキの高さ = ハガキの上下の余白
                    const space: number = setPageSize - hagakiHeight;
                    // ハガキはページエリアの中心中央に配置される想定
                    contoroller._vue.$data.FrameId.top = Math.ceil(space / 2) + "px";
                }

                // ページエリアのサイズ変更に合わせて吹き出しの位置を調整
                {
                    // ページエリアサイズ(長辺)から、ハガキの幅算出
                    const hagakiWidth: number = setPageSize;
                    contoroller.setGuidanceBalloonPos(editAreaWidth, setPageSize, hagakiWidth);
                    contoroller.setImgBorderGuidanceBalloonPos(editAreaWidth, setPageSize, setPageSize * ratio, false);
                }
            }
            else {
                // 縦長テンプレートの場合

                // ページエリアのサイズ変更に合わせて吹き出しの位置を調整
                {
                    // ページエリアサイズ(長辺)から、ハガキの幅算出
                    const hagakiWidth: number = setPageSize * ratio;
                    contoroller.setGuidanceBalloonPos(editAreaWidth, setPageSize, hagakiWidth);
                    contoroller.setImgBorderGuidanceBalloonPos(editAreaWidth, setPageSize, hagakiWidth, true);
                }
            }

        }
        else {
            // SPの場合
            // sonbpへ通知
            contoroller.sonbpIfController.resizeContents(null);

            // 赤枠の吹き出しの位置調整
            contoroller.setSpImgBorderGuidanceBalloonPos(
                contoroller.sonbpIfController.PdfPageSizeHeight,
                contoroller.sonbpIfController.PdfPageSizeWidth);
        }
    }

    /**
     * ページエリア、ハガキサイズに連動して赤枠ガイダンス表示位置を調整(SP)
     * @param pdfHeight ：PDFエリアの高さ
     */
    private setSpImgBorderGuidanceBalloonPos(pdfHeight, pdfWidth) {
        // 編集エリア
        const editAreaHeight: number = $("#editArea").height();
        const editAreaWidth: number = $("#editArea").width();

        // 吹き出しの高さ
        const popUpHeight = 25;

        // 表示幅から表示している高さを計算
        const ratio = editAreaWidth / pdfWidth;
        const hagakiHeight = pdfHeight * ratio;

        // 同じSPでも画面の大きさによって表示範囲が異なるため、その対応
        const space = hagakiHeight > editAreaHeight ? (editAreaWidth - pdfWidth) / 2 : (editAreaHeight - hagakiHeight) / 2;
        const topPos = hagakiHeight > editAreaHeight ? editAreaHeight - popUpHeight : hagakiHeight + space - popUpHeight;        

        this._vue.$data.ReplaceImgGuideBaloon.top = topPos + "px";
        this._vue.$data.ReplaceImgGuideBaloon.left = "10px";
    }

    /**
     * ページエリア、ハガキサイズに連動して赤枠ガイダンス表示位置を調整(PC)
     * @param editAreaWidth ：編集エリアの幅
     * @param pageSize      ：ハガキのサイズ(長辺)
     * @param minPageSize   ：ハガキのサイズ(短辺)
     * @param partrait      ：ハガキが縦長かどうか
     */
    private setImgBorderGuidanceBalloonPos(editAreaWidth: number, pageSize: number, minPageSize: number, isPortrait: boolean) {

        // ハガキの幅と高さ
        const hagakiWidth = isPortrait ? minPageSize : pageSize;
        const hagakiHeight = isPortrait ? pageSize : minPageSize;

        // ハガキの余白:　編集エリアの横幅 - ハガキの幅
        const spaceWidth: number = editAreaWidth - hagakiWidth;

        // X座標：余白 + 赤枠分
        const redWidthRate = isPortrait ? 0.05 : 0.03;
        this._vue.$data.ReplaceImgGuideBaloon.left = (Math.ceil(spaceWidth / 2) + Math.ceil(hagakiWidth * redWidthRate)) + "px";

        // ハガキの上下の余白
        const editHeight = $('#editArea').height();
        const typeNoHeight = $('#editArea .p-editCanvasArea__framId').outerHeight(true);
        const printAreaHeight = $('#printWarning').height();
        const screenHeight = editHeight - typeNoHeight - printAreaHeight;
        const spaceHeight: number = Math.ceil((screenHeight - hagakiHeight) / 2);

        // 吹き出しの高さ
        // 表示していない場合は要素の高さを取得できないため、取得できない場合は固定値とする
        const elm = this._vue.$refs.imageGuidance as HTMLInputElement
        const guideHeight: number = this._vue.$data.Show.ImgGuidance ? elm.getBoundingClientRect().height + 20 : 95;

        // Y座標：ハガキのページエリアの高さ + 上下の余白 - 赤枠と吹き出し位置を考慮した値
        this._vue.$data.ReplaceImgGuideBaloon.top = (hagakiHeight + spaceHeight - guideHeight) + "px";
    }

    /**
     * ページエリア、ハガキサイズに連動してガイダンス表示位置を調整
     * @param editAreaWidth ：編集エリアの場合
     * @param pageSize      ：ページサイズ(長辺)
     * @param hagakiWidth   ：ハガキの幅
     */
    private setGuidanceBalloonPos(editAreaWidth: number, pageSize: number, hagakiWidth: number) {

        // ページエリアサイズ(長辺) - ハガキの幅 = ハガキの左右の余白
        const space: number = editAreaWidth - hagakiWidth;

        // X座標：ハガキはページエリアの中心中央に配置される想定 +15は吹き出しのとんがり部分など考慮分
        this._vue.$data.ReplaceGuidanceBalloon.left = (hagakiWidth + Math.ceil(space / 2) + 15) + "px";

        // Y座標
        this._vue.$data.ReplaceGuidanceBalloon.top = Math.ceil(pageSize / 2) + "px";

    }


    /**
     * 業務側初期処理
     */
    private async doOnload(): es6promise.Promise<void> {

        if (MultiTab.isOldTab()) {
            Logger.log("複数タブ操作 古いタブの為初期化を中断しました。");
            return;
        }

        Logger.log("業務側初期処理 開始");


        // getパラメータの取得
        common.setGetParam();

        // 認証トークン取得
        this.getAuthToken();

        const prePagePreview: boolean = this.checkFromPrev();
        const browserReload: boolean = this.checkBrowserReload();

        Logger.debug("テンポラリデータ初期化呼び出し");

        // テンポラリデータ初期化(WebAPI)呼び出し
        let initTemp: initTempResponseEntity;
        if (prePagePreview || browserReload) {
            // プレビュー画面から戻ってきた,F5の場合は初期化しない.
            initTemp = new initTempResponseEntity();
            initTemp.photoControll = new photoControll();
            initTemp.photoControll.leavePhoto = false;
            if (prePagePreview) {
                Logger.debug("初期化ルート：プレビュー画面から来た");
            } else if(browserReload) {
                Logger.debug("初期化ルート：F5押された");
            }
        } else {
            // 通常ルートは初期化する.
            initTemp = await this.initTemp(this.authToken);
            Logger.debug("初期化ルート：通常");
        }

        if (initTemp === null) {
            Logger.error("テンポラリデータ初期化 失敗");
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(1)', function () {
                dialogUtil.closeErrorDialog();
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
            });
            return;
        }

        Logger.debug("編集情報取得呼び出し");

        // 編集情報取得(WebAPI)呼び出し
        const that = this;
        this.editInfo = await this.getEditInfo(this.authToken, prePagePreview);
        if (this.editInfo === null) {
            Logger.error("編集情報取得呼び出し 失敗");
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(2)', function () {
                dialogUtil.closeErrorDialog();
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
                window.location.href = that._retailerConfig.returnTop;
            });
            return;
        }
        this.kumihanToken = this.editInfo.kumihanToken;

        Logger.debug("indexedDBの初期化");

        // indexedDBの初期化
        let idbEditInfo: idbEdit.editInfo;
        idbEditInfo = editStrage.initStorage(initTemp.photoControll.leavePhoto, prePagePreview, browserReload, this.editInfo.info.saveAs,this.editInfo.master.design.dsnNo);
        if (!idbEditInfo) {
            Logger.debug("WebStorageの初期化失敗");
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(3)', function () {
                dialogUtil.closeErrorDialog();
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
            });
            return;
        }


        // テンプレート期限チェック
        if (this.editInfo.master.design.isExpire) {
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_DESIGN_EXPIRED_TEXT, function () {
                window.location.href = that._retailerConfig.orderHistory;
            });
            return;
        }

        // 編集期限チェック
        if (this.editInfo.info.isExpire) {
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_DATA_EXPIRED_TEXT, function () {
                window.location.href = that._retailerConfig.orderHistory;
            });
            return;
        }

        // 注文停止チェック
        if (this.editInfo.master.design.orderStop == EditConst.PRINT_TYPE_BOTH) {
            // 受付停止中
            let msg = this._retailerConfig.id == EditConst.KITAMURA ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT;
            dialogUtil.createErrorDialog(msg, function () {
                    window.location.href = that._retailerConfig.orderHistory;
            });
            return;

        } else if (this.editInfo.master.design.orderStop == EditConst.PRINT_TYPE_PRINT) {
            // 印刷停止中
            if (this.editInfo.master.design.printType == EditConst.PRINT_TYPE_BOTH) {

                // 印刷停止中デザインのため、銀塩に切り替えます。
                let msg = this._retailerConfig.id == EditConst.KITAMURA ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT;
                dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
                this.editInfo.master.design.printType = EditConst.PRINT_TYPE_GINEN;

            } else {
                let msg = this._retailerConfig.id == EditConst.KITAMURA ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT;
                dialogUtil.createErrorDialog(msg, function () {
                    window.location.href = that._retailerConfig.orderHistory;
                });
                return;
            }

        } else if (this.editInfo.master.design.orderStop == EditConst.PRINT_TYPE_GINEN) {
            // 銀塩停止中
            if (this.editInfo.master.design.printType == EditConst.PRINT_TYPE_BOTH) {

                // 銀塩停止中デザインのため、印刷に切り替えます。
                let msg = this._retailerConfig.id == EditConst.KITAMURA ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT;
                dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
                this.editInfo.master.design.printType = EditConst.PRINT_TYPE_PRINT;

            } else {
                let msg = this._retailerConfig.id == EditConst.KITAMURA ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_ORDER_STOP_TEXT;
                dialogUtil.createErrorDialog(msg, function () {
                    window.location.href = that._retailerConfig.orderHistory;
                });
                return;
            }
        }

        // リテーラ出力タイプ判定 -> 設定されているアウトプットに応じたデザイン以外がきたら返す。
        //if (this._retailerConfig.poscaSettings.printType != EditConst.PRINT_TYPE_BOTH) {
        //    if (this.editInfo.master.design.printType != this._retailerConfig.poscaSettings.printType) {
        //        dialogUtil.createErrorDialog(constDialogMessage.ERROR_DESIGN_PRINTTYPE_INDVALID_TEXT, function () {
        //            window.location.href = that._retailerConfig.orderHistory;
        //        });
        //        return;
        //    }
        //}

        // 1枚無料チェック
        if (this.editInfo.isTrial) {

            // デザイン選択画面に戻る。

            // 許可されているリテーラか？
            if (!this._retailerConfig.poscaSettings.allowTrial) {
                dialogUtil.createErrorDialog(constDialogMessage.ERROR_TRIAL_RETAILER_INVALID, function () {
                    window.location.href = that._retailerConfig.returnTop;
                });
                return;
            }

            // 年賀デザインか                  
            if (this.editInfo.master.design.dsnType != EditConst.NENGA) {
                dialogUtil.createErrorDialog(constDialogMessage.ERROR_TRIAL_DESIGN_INVALID, function () {
                    window.location.href = that._retailerConfig.returnTop;
                });
                return;
            }
            
        } else {
            // 1枚無料でなければ一時保存ボタンを表示する。
            this._vue.$data.Show.SaveButton = true;
        }

        // URLの補完
        this.editInfo.master.font.forEach(row => row.url = this.URL_GETIMAGE + row.url);
        this.editInfo.master.greeting.forEach(row => row.url = this.URL_GETIMAGE + row.url);

        // vueオブジェクトに連携
        let defFontColor: GetEditInfo.GetEditInfoColorEntity;
        {
            if (this._usePcDesign) {
                this._vue.$data.FrameId.val = this.editInfo.master.design.dsnNo;
            }
            this._vue.$data.ColorOptions = this.editInfo.master.color;
            this._vue.$data.FontOptions = this.editInfo.master.font.sort((f, s) => {
                var r = 0;
                if (f.seq < s.seq) { r = -1; }
                else if (f.seq > s.seq) { r = 1; }
                return r;
            });

            // デフォルトフォントカラー
            defFontColor = util.relic.listFind(this.editInfo.master.color, (clr: GetEditInfo.GetEditInfoColorEntity) => {
                return clr.id == this.editInfo.master.design.fontColor;
            });
            if (!defFontColor) {
                defFontColor = this.editInfo.master.color[0];
            }
            // 文字色
            this._vue.$data.SelectCharColor = defFontColor.id;
            // フチ文字は白(1番目)を選択
            this._vue.$data.SelectOutlineCharColor = this.editInfo.master.color[0].id;
            // 手書きスタンプ色
            this._vue.$data.SelectTegakiColor = "";

            // デフォルトフォント名取得
            const defFont: GetEditInfo.GetEditInfoFontEntity = this.getDefaultFont();
            
            // あいさつ文
            this.editInfo.master.greeting.forEach(row => row.selected = false);
            this._vue.$data.GreetingInfo.Font = defFont.name;
            this._vue.$data.GreetingInfo.FontSample = defFont.url;

            // 差出人
            this._vue.$data.SenderInfo.Setting.Font = defFont.name;
            this._vue.$data.SenderInfo.Setting.FontSample = defFont.url;

            // スタンプ
            this._vue.$data.Stamp.CategoryOptions.push({ code: 0, label: this.STAMP_CATEGORY_ALL });
            for (let i: number = 0; i < this.editInfo.master.stampCategory.length; i++) {
                this._vue.$data.Stamp.CategoryOptions.push({ code: i + 1, label: this.editInfo.master.stampCategory[i] });
            }
            this._vue.$data.Stamp.Cagegory = this._vue.$data.Stamp.CategoryOptions[1].label;

            //デザインマスタ機能制限
            if (this.editInfo.master.design.editMode == EditConst.DSN_MST_EDIT_MODE_LIMIT) {
                this._vue.$data.Show.PhotoI2AsDsn = false;
                this._vue.$data.Show.GreetingMenuAsDsn = false;
                this._vue.$data.Show.StampMenuAsDsn = false;
                this._vue.$data.Show.MyStampMenuAsDsn = false;
                this._vue.$data.Show.TegakiStampMenuAsDsn = false;
            }
        }

        // sonbpコントローラに連携
        this.sonbpIfController.tempId = this.editInfo.tempId;
        this.sonbpIfController.encCreateDate = this.editInfo.encCreateDate;
        this.sonbpIfController.AuthToken = this.authToken;
        this.sonbpIfController.PutRange = this.putRange;
        this.sonbpIfController.PutRangeStamp = this.putRangeStamp;
        this.sonbpIfController.GreetingDesign = this.editInfo.master.design.greeting;
        this.sonbpIfController.SenderDesign = this.editInfo.master.design.sender;
        this.sonbpIfController.DefaultFontColor = defFontColor;
        this.sonbpIfController.ColorMasterList = this.editInfo.master.color;
        this.sonbpIfController.DesignMaster = this.editInfo.master.design;

        // あいさつ文一覧の復元
        this.sonbpIfController.restoreGreetingList(prePagePreview, idbEditInfo.greetingInfo, this.editInfo.info.greeting, this.editInfo.master.font, this.editInfo.master.color);

        Logger.debug("あいさつ文一覧の復元", this.sonbpIfController.GreetingList);

        // 差出人情報の復元
        if (this.editInfo.info.sender && this.editInfo.info.sender.senderInfo.addresses.length > 0) {
            this.sonbpIfController.restoreSenderInfo(this.editInfo.info.sender, this.editInfo.master.font, this.editInfo.master.color);
            this._vue.$data.SenderInfo.Setting.FontSample = this.setFontSample(this.editInfo.info.sender.font);
        }
        else {
            this.sonbpIfController.SenderInfo = senderTranEntityEx.createDef(this.editInfo.master.design.sender, this.editInfo.master.font, this.editInfo.master.color);
        }
        this._vue.$data.SenderInputData = this.sonbpIfController.SenderInfo;

        Logger.debug("差出人情報の復元", this.sonbpIfController.SenderInfo);


        // 画像一覧にアップロード数分の画像枠を用意
        this._photoLogic.restoreUoloadPhotoList(!initTemp.photoControll.leavePhoto, true, idbEditInfo, this.editInfo);


        // 画像枠情報の復元
        let setLen = 0;
        for (let i: number = 0; i < this.editInfo.info.photoUse.length; i++) {
            const pf: photoFrame = new photoFrame();
            pf.fileId = this.editInfo.info.photoUse[i].fileId;
            pf.idx = this.editInfo.info.photoUse[i].idx + "";
            pf.useI2 = this.editInfo.info.photoUse[i].isUseI2;
            pf.brightId = this.editInfo.info.photoUse[i].brightId;
            this.sonbpIfController.PhotoFrameList.push(pf);
            setLen++;
        }
        Logger.debug("画像枠情報の復元", this.sonbpIfController.PhotoFrameList);

        // スタンプのマスタ情報の連携
        this.editInfo.master.stamp.forEach(row => row.url = this.URL_GETIMAGE + row.url);
        this._vue.$data.MasterStampList = this.editInfo.master.stamp;


        // Myステッカーのアップロード情報の復元
        this._myStampLogic.restoreUoloadList((prePagePreview || browserReload), false, idbEditInfo?.myStampList, this.editInfo.info.myStamp);

        // 手書きスタンプのアップロード情報の復元
        this._tegakiStampLogic.restoreUoloadList((prePagePreview || browserReload), false, idbEditInfo?.fontgenicList, this.editInfo.info.fontgenic);


        // 有効高さ判定(流用元が[600]pxまでは許容していた模様。iPhone5は[568]のため調整)
        const controllerHeight: number = $("#editController").height();
        if (controllerHeight < 600) {
            this._vue.$data.ShortSize = true;
        }
        Logger.debug("controllerHeight [" + controllerHeight + "] ShortSize[" + this._vue.$data.ShortSize + "]");

        Logger.log("sonbp初期化＆sonbp起動");
        this.sonbpIfController.Vue = this._vue;
        this.sonbpIfController.setOnChangeInitFunc((editMode: editModeKind, vps: itemVenderProperty): void => {

            switch (vps?.item_type) {
                case sonbpIfconst.ITYPE_PHOTO_BOX:
                    if (this._usePcDesign) {

                        if (vps.file_id == "@DUMMY@" || editMode == EDIT_MODE_KIND.SET_PHOTO)
                            this._photoLogic.btnClickSetPhotoMenu(null, vps);
                        else
                            this._photoLogic.btnClickManiPhotoMenu(null, vps);
                    } else {
                        if (editMode != EDIT_MODE_KIND.MANI_PHOTO)
                            this._photoLogic.btnClickSetPhotoMenu(null, vps);
                    }
                    break;

                case sonbpIfconst.ITYPE_STAMP_IMG:
                    this._mstStampLogic.btnClickStampMenu(null, vps);
                    break;

                case sonbpIfconst.ITYPE_MYSTAMP_IMG:
                    this._myStampLogic.btnClickStampMenu(null, vps);
                    break;

                case sonbpIfconst.ITYPE_GREETING_TXT:
                    this._greetingLogic.btnClickGreetingMenu(null, vps);
                    break;

                case sonbpIfconst.ITYPE_SENDER_TXT:
                    this._senderLogic.btnClickSenderMenu(null, vps);
                    break;

                case sonbpIfconst.ITYPE_FONTGENIC_IMG:
                    this._tegakiStampLogic.btnClickStampMenu(null, vps);
                    break;
            }
        });
        this.sonbpIfController.start(this.pageAreaOffset).then(async (sonbpRes: boolean) => {
            // 画像存在チェック
            let photoList: string[] = [];
            let mystampList: string[] = [];
            let fontgenicList: string[] = [];

            this.sonbpIfController.getPhotoList((list: itemVenderProperty[]) => {
                photoList = list.map(v => v.file_id).filter(v => v !== this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID);
            }, () => { });
            this.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
                mystampList = list.map(v => v.file_id);
            });
            this.sonbpIfController.getTegakiStampList((list: itemVenderProperty[]) => {
                fontgenicList = list.map(v => v.file_id);
            });

            // 画像が1枚でもあれば再編集と判断し、チェックAPIを実行
            if (photoList.length > 0 || mystampList.length > 0 || fontgenicList.length > 0) {
                // sonbpの使用画像とサーバのアップロード一覧のチェック
                var checkRet = await this.getCheckUploadImagesInfo(this.authToken, photoList, mystampList, fontgenicList);
                if (checkRet !== null) {
                    let target: string = "";

                    if (!checkRet.photo)     target += "・写真<br>";
                    if (!checkRet.mystamp)   target += "・写真スタンプ<br>";
                    if (!checkRet.fontgenic) target += "・手書きスタンプ<br>";
                    if (!checkRet.photo || !checkRet.mystamp || !checkRet.fontgenic) {
                        dialogUtil.createErrorDialog(target + constDialogMessage.WARN_EDIT_CHECKUPLOADIMAGES, function () {
                            dialogUtil.closeErrorDialog();
                        });
                    }
                } else {
                    dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHECKUPLOADIMAGES, function () {
                        dialogUtil.closeErrorDialog();
                    });
                }
            } else {
                Logger.debug("画像存在チェック不要");
            }

            // 結果判定
            if (sonbpRes) {

                Logger.debug("sonbpへの設定モード[" + this.sonbpIfController.EditMode + "]");
                this.editMode = this.sonbpIfController.EditMode;

                let showGuidance1PC = false;
                let showFristGuidance = false;

                if (this._usePcDesign) {
                    // PC用
                    // ガイダンスの表示制御
                    if (this.showGuidance(prePagePreview, this.doReloadedAccess, true)) {
                        // ある場合
                        showGuidance1PC = true;
                        await this.getGuidanceImgSrcList();
                        dialogUtil.showGuidance1Dlg(this.guidanceImgSrcList)
                            .then(() => console.debug("ガイダンス正常終了"))
                            .catch(() => console.debug("ガイダンス異常終了"))
                            .finally(() => {
                                showGuidance1PC = false;
                                this._vue.$data.Show.FirstGuidance = showFristGuidance;
                            });
                    }
                } else {
                    // SP用
                    // ガイダンスの表示制御
                    if (this.showGuidance(prePagePreview, this.doReloadedAccess, this.sonbpIfController.ExistsPhotoBox)) {
                        await this.getGuidanceImgSrcList();
                        // ある場合
                        $("#guidanceImage1").css("background-image", `url(${this.guidanceImgSrcList[0]})`);
                        $("#guidanceImage2").css("background-image", `url(${this.guidanceImgSrcList[1]})`);
                        $("#guidanceImage3").css("background-image", `url(${this.guidanceImgSrcList[2]})`);
                        $("#guidanceImage4").css("background-image", `url(${this.guidanceImgSrcList[3]})`);
                        $("#guidanceImage5").css("background-image", `url(${this.guidanceImgSrcList[4]})`);
                        $("#guidance1").removeClass("visHidden");
                        $("#guidance2").removeClass("visHidden");
                        $("#guidance3").removeClass("visHidden");
                        $("#guidance4").removeClass("visHidden");
                        $("#guidance5").removeClass("visHidden");
                        this._vue.$data.Show.ScreenLock = true;
                        this._vue.$data.Show.Guidance1 = true;

                    }
                    else {
                        // 上記以外の場合
                        this._vue.$data.Show.ScreenLock = false;
                    }
                }

                // 画面構成パーツの表示制御
                // sonbpに設定したモードを判定
                if (this._usePcDesign) {
                    if (this.sonbpIfController.EditMode === EDIT_MODE_KIND.SET_PHOTO && this.sonbpIfController.ExistsPhotoBox) {
                        // 画像読込・配置モードの場合

                        if (this._usePcDesign) {
                            // PC用
                            // 画像一覧の件数判定
                            if (this._photoLogic.NotEmptyUploadNum === 0) {
                                // 0件の場合
                                showFristGuidance = true;
                                this._vue.$data.Show.FirstGuidance = !showGuidance1PC;
                            }
                            this._vue.$data.Show.BalloonGuidance = true;

                            this._vue.$data.Show.PhotoList = true;
                            this._vue.$data.Show.OparatePallet = true;

                            this._vue.$data.Show.ToolMenu = true;

                            // ツールメニューの表示制御
                            this._vue.$data.Show.FinishSelectMenu = false;
                            this._vue.$data.ActiveSetPhotoMenu = true;
                        }

                        // オブジェクト操作パレットの制御
                        this.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);
                    }
                    else {
                        // テンプレートに画像枠がない場合

                        // 出力タイプ判定
                        if (this.sonbpIfController.EditMode === EDIT_MODE_KIND.SET_PHOTO && !this.sonbpIfController.ExistsPhotoBox) {
                            // 銀塩・印刷両方

                            // 仕上がり選択だけできる、特殊な画像読込・配置モードを設定
                            this._vue.$data.Show.FirstGuidance = false;
                            this._vue.$data.Show.BalloonGuidance = false;
                            this._vue.$data.Show.PhotoList = false;
                            this._vue.$data.Show.ToolMenu = true;
                            this._vue.$data.Show.OparatePallet = true;

                            // ツールメニューの表示制御
                            this._vue.$data.ActiveSetPhotoMenu = false
                            this._vue.$data.Show.SetPhotoMenu = false;
                            this._vue.$data.Show.ManiPhotoMenu = false;
                            this._vue.$data.Show.FinishSelectMenu = true;
                            this._vue.$data.ActiveFinishSelectMenu = true;

                            // オブジェクト操作パレットの制御
                            this.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);
                        }
                        else {
                            // 上記以外
                            if (this.sonbpIfController.EditMode === EDIT_MODE_KIND.SENDER) {
                                // 差出人操作モード
                                this._senderLogic.InitSenderPallet();
                                this._vue.$data.Show.FirstGuidance = false;
                                this._vue.$data.Show.BalloonGuidance = false;
                                this._vue.$data.Show.ToolMenu = true;
                                this._vue.$data.Show.OparatePallet = true;
                                this._vue.$data.Show.SenderPanel = true;
                                this._vue.$data.Show.FinishSelectMenu = false;
                                this._vue.$data.Show.HideButton = true;

                                // ツールメニューの表示制御
                                this._vue.$data.Show.SetPhotoMenu = false;
                                this._vue.$data.Show.ManiPhotoMenu = false;
                                this._vue.$data.Show.GreetingMenu = true;
                                this._vue.$data.ActiveSenderMenu = true;

                                // オブジェクト操作パレットの制御
                                this.setModeOparatePallet(EDIT_MODE_KIND.SENDER, null);
                            }
                            else {
                                // 上記以外の場合(あいさつ文操作モードを想定)
                                this._vue.$data.Show.FirstGuidance = false;
                                this._vue.$data.Show.ToolMenu = false;
                                this._vue.$data.Show.OparatePallet = true;
                                this._vue.$data.Show.GreetingPanel = false;
                                this._vue.$data.Show.FinishSelectMenu = false;

                                // ツールメニューの表示制御
                                this._vue.$data.Show.SetPhotoMenu = false;
                                this._vue.$data.Show.ManiPhotoMenu = false;
                                this._vue.$data.Show.GreetingMenu = false;
                                this._vue.$data.Show.SenderMenu = false;
                                this._vue.$data.ActiveGreetingMenu = true;

                                // オブジェクト操作パレットの制御
                                this.setModeOparatePallet(EDIT_MODE_KIND.GREETING, null);
                            }
                        }
                    }
                }
                else {
                    // SP用
                    // →画像読込・配置モード 一択
                    // 画像枠の個数判定
                    this.sonbpIfController.getPhotoList((list: itemVenderProperty[]) => {
                        if (1 < list.length) {
                            // 画像枠複数ありの場合
                            this._vue.$data.Show.SwapItemMenu = true;
                        }
                        else {
                            // 上記以外の場合
                            this._vue.$data.Show.SwapItemMenu = false;
                        }

                        this._vue.$data.Show.FinishSelectMenu = (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_BOTH) ? true : false;
                    }, () => { });

                    // オブジェクト操作パレットの制御
                    this.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);
                }

                // モードとは別に差出人デザイン情報がない場合は、メニューを非表示
                this._vue.$data.Show.SenderMenu = (that._senderLogic.ExistsSenderDesgin) ? true : false;

                // 仕上がり選択->デフォルト銀塩、印刷で保存している場合は保存状態復帰
                let setModeGinen: boolean = true;
                if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_BOTH) {

                    const printType: string = prePagePreview ? idbEditInfo.printType : this.editInfo.info.printType;

                    // 銀塩・印刷 両方
                    if (printType) {
                        if (printType === EditConst.PRINT_TYPE_PRINT) {
                            setModeGinen = false;
                        }
                    }
                    else {
                        if (this.editInfo.master.design.defPrintType === EditConst.PRINT_TYPE_PRINT) {
                            setModeGinen = false;
                        }
                    }
                }
                else if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_PRINT) {
                    // 印刷専用
                    setModeGinen = false;
                }
                else {
                    // 上記以外(銀塩を想定)
                    setModeGinen = true;
                }

                // 判定
                if (setModeGinen) {
                    this.sonbpIfController.setAreaView(sonbpIfconst.ATYPE_GINEN);
                } else {
                    this.sonbpIfController.setAreaView(sonbpIfconst.ATYPE_PRING);
                }
                this._vue.$data.FinishSelect.isGinen = setModeGinen;

                // 仕上がりのメッセージを表示
                this.setImgGuidanceMesage(setModeGinen);

                // F5リロード時のスタンプ補完
                if (prePagePreview || browserReload) {
                    this.resetUpdateListOfStamps();
                }

                // スタンプの利用有無同期
                this.resetUsedOfStamps();

                // 次へボタンの活性制御
                this.allowNextPage((allow: boolean) => {
                    this._vue.$data.EnableNextPageBtn = allow;
                });

                this.loadComplited = true;

                // 表示制限解除
                this.cancelRestrction();
            }
            else {
                // sonbp起動失敗
                Logger.error("sonbp起動失敗-1");
                dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(4)', function () {
                    dialogUtil.closeErrorDialog();
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                });
                return;
            }
        }).then(() => {

            // 編集モード判定
            if (this.sonbpIfController.EditMode === EDIT_MODE_KIND.SET_PHOTO) {
                // 画像読込・配置モードの場合(何かしら画像をアップしていたらサムネイルを取得する。)
                if (0 < this._photoLogic.NotEmptyUploadNum || 0 < this._tegakiStampLogic.NotEmptyUploadNum || 0 < this._myStampLogic.NotEmptyUploadNum) {
                    Logger.debug("画像サムネイルダウンロード開始");
                    this.getAllUploadThumbnails().then(() => {

                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();
                    }).catch(() => {
                        Logger.error("画像サムネイルダウンロード 失敗");
                        dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(6)' + "]", function () {
                            dialogUtil.closeErrorDialog();
                            // ローディングダイアログ終了
                            util.dialogUtil.closeLoading();
                        });
                    });
                }
                else {
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                }
            }
            else {
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
            }

            // SSO
            Logger.log("SSO開始");
            SSO.DoSSO(this.authToken, this._retailerConfig.id); 

            try {
                new AdjustRecord(
                    this._retailerConfig.extrSettings.adjust?.token,
                    this._retailerConfig.extrSettings.adjust?.eventID.editStart);
            } catch(er) {
                Logger.error(`AdjustError:${er}`);
            }

        }).catch((err: number) => {
            Logger.error("sonbp起動失敗-2 [" + err + "]");
            dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM + '(5)' + "[" + err + "]", function () {
                dialogUtil.closeErrorDialog();
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
            });
            return;
        });

        // 外字情報のセット
        this._gaijiLogic.SetGaijiList(this.editInfo.master.gaijiList);

    }

    /**
     * フォントサンプル画像変更
     * @param fontId
     */
    private setFontSample(fontId: string) {
        // フォント設定していない場合は初期値を返却
        if (this._vue.$data.SenderInfo.Setting.Font == "") {
            return this.editInfo.master.font[0].url;
        }

        const selFont = this.editInfo.master.font.find(x => x.id == fontId);
        return selFont.url;
    }

    /**
     * デフォルトフォントを取得
     */
    public getDefaultFont(): GetEditInfo.GetEditInfoFontEntity {

        let result: GetEditInfo.GetEditInfoFontEntity;

        // デザインマスタで指定されたフォントを検索
        const defFont: GetEditInfo.GetEditInfoFontEntity = util.relic.listFind(this.editInfo.master.font, (f: GetEditInfo.GetEditInfoFontEntity) => {
            return f.id === this.editInfo.master.design.fontType;
        })

        if (defFont) {
            // 該当ありの場合
            result = defFont;
        }
        else {
            // 上記以外の場合
            result = this.editInfo.master.font[0];
        }

        return result;
    }

    /**
     * 認証トークン取得
     */
    private getAuthToken(): void {
        // hiddenから認証トークン取得＆クリア 
        // -> クリアするとSafariでブラウザバックしたときにTokenが空になってしまうので消さない
        this.authToken = $("#Token").val();
        //$("#Token").val("");
    }

    /**
     * ガイダンスの表示制御
     * @param prePagePreview    ：プレビュー画面からの遷移？
     * @param doReloadedAccess  ：F5リロードアクセス？
     * @param existsPhotoBox    ：テンプレートに画像枠あり？
     */
    private showGuidance(prePagePreview: boolean, doReloadedAccess: boolean, existsPhotoBox: boolean): boolean {

        let result: boolean = true;
       
        // 再編集フラグ取得
        const isEdit: boolean = this.getIsEdit();

        Logger.debug("showGuidance prePagePreview[" + prePagePreview + "] existsPhotoBox[" + existsPhotoBox + "] isEdit[" + isEdit + "] doReloadedAccess[" + this.doReloadedAccess + "]");

        // 表示条件判定
        if (doReloadedAccess || prePagePreview || !existsPhotoBox || isEdit || this.editInfo.master.design.dsnType === EditConst.MOCYU) {
            result = false;
        }

        Logger.debug("showGuidance[" + result + "]");

        return result;
    }

    /**
     * ガイダンス画像を対象img要素に適用
     */
    private async getGuidanceImgSrcList() {
        var url = this._usePcDesign ? "img/pc/desktop/default/startup_guidance_0" : "/posca/img/sp/common/default/startup_guidance_sp_0";
        this.guidanceImgSrcList = [];
        for (let i: number = 1; i <= 5; i++) {
            var infix = this._retailerConfig.id == "1" && i == 5 ? "_kitamura" : "";
            await util.ajax.postforblob_get(`${url}${i}${infix}.png`, "").then((b: Blob) => {
                var url = window.URL || window.webkitURL;
                this.guidanceImgSrcList.push(url.createObjectURL(b));
            })
        }
    }

    /**
     * 表示制限解除
     */
    private cancelRestrction(): void {

        // Vueオブジェクト生成前に表示したくないパーツの制限を解除
        if (this._usePcDesign) {
            // PCの場合

            $("#contents").removeClass("transparent");
            $("#flowButtonArea").removeClass("transparent");
            $("#fullScreenGuidanceArea").removeClass("transparent");
            $("#dialogArea").removeClass("visibility-hidden");
        }
        else {
            // SPの場合
            $("#closeEvent").removeClass("close-event");
            $("#header").removeClass("visHidden");
            $("#footer").removeClass("visHidden");
            $("#dialogArea").removeClass("visHidden");
            $("#flowButtonArea").removeClass("visHidden");
            $("#commentEditPage").removeClass("visHidden");
            $("#senderEditPage").removeClass("visHidden");
            $(".imageListScroll").removeClass("visHidden");
            $(".stampScroll").removeClass("visHidden");
            $("#footerMenu").removeClass("visHidden");
            $("#messageArea").removeClass("visHidden");
        }
    }

    /**
     * テンポラリデータ初期化(WebAPI)呼び出し
     * @param authToken 認証トークン
     */
    private async initTemp(authToken: string): es6promise.Promise<initTempResponseEntity> {

        let result: initTempResponseEntity;

        // 入力パラメータ
        const param = {
            token: authToken
        }

        await util.ajax.post(this.WEBAPI_URL_INITTEMP, JSON.stringify(param)).then((resData: initTempResponseEntity) => {
            result = resData;

            Logger.debug("WebAPI_InitTemp result[" + JSON.stringify(result) + "]");

        }).catch(() => {

            result = null;
        });

        return result
    }

    /**
     * 編集情報取得(WebAPI)呼び出し
     * @param authToken     ：認証トークン
     * @param sessionSender ：セッションの差出人を使用するか？
     */
    private async getEditInfo(authToken: string, sessionSender: boolean): es6promise.Promise<GetEditInfo.GetEditInfoResponseEntity> {

        let result: GetEditInfo.GetEditInfoResponseEntity;

        // 入力パラメータ
        const param = {
            token: authToken,
            sessionSender: sessionSender
        }
        await util.ajax.post(this.WEBAPI_URL_GETEDITINF, JSON.stringify(param)).then((resData: GetEditInfo.GetEditInfoResponseEntity) => {
            result = resData;

            //Logger.debug("WebAPI_GetEditInfo  result[" + JSON.stringify(result) + "]");

        }).catch(() => {

            result = null;
        });

        return result
    }

    /**
     * 画像存在チェック(WebAPI)呼び出し
     * @param authToken     ：認証トークン
     */
    private async getCheckUploadImagesInfo(authToken: string, photoList: string[], mystampList: string[], fontgenicList: string[]): es6promise.Promise<GetEditInfo.GetEditInfoCheckUploadImagesEntity> {

        let result: GetEditInfo.GetEditInfoCheckUploadImagesEntity;

        // 入力パラメータ
        const param = {
            Token: authToken,
            photoList: photoList,
            mystampList: mystampList,
            fontgenicList: fontgenicList
        }
        await util.ajax.post(this.WEBAPI_URL_CHECKUPLOADIMAGES, JSON.stringify(param)).then((resData: GetEditInfo.GetEditInfoCheckUploadImagesEntity) => {
            result = resData;

            Logger.debug("WebAPI_CheckUploadImages  result[" + JSON.stringify(result) + "]");

        }).catch(() => {
            result = null;
        });

        return result
    }

// #endregion

// #region ■メソッド（内部制御系）

    /**
     * 次へボタンの活性制御判定
     * */
    public allowNextPage(nextFunc: (allow: boolean) => void) {

        this.sonbpIfController.getPhotoList(
            (list: itemVenderProperty[]) => {
                if (list.length === 0) {
                    nextFunc(true);
                }
                else {
                    const emptyItem: itemVenderProperty = util.relic.listFind(list, (p: itemVenderProperty) => {
                        return p.file_id === this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID;
                    })

                    if (emptyItem === undefined) {
                        nextFunc(true);
                    }
                    else {
                        nextFunc(false);
                    }
                }
            },
            () => {
                nextFunc(false);
            });

    }

    /**
     * タッチイベントを制御します。
     * @param allow
     */
    public touchEventChange(allow: boolean): void {

        // -> SP版の編集画面ではピンチアウトできないことにしたが、
        // ピンチアウトする場合のときのためにこの関数を残しておく。
        /*this._vue.$data.AllowTouchEvent = allow;*/
    }

    /**
     * オブジェクト操作パレットの項目表示制御
     * @param editMode      ：編集モード
     * @param selectItem    ：選択アイテム情報
     */
    public setModeOparatePallet(editMode: string, selectItem: itemVenderProperty) {

        if (this._usePcDesign) {
            // PC用
            this.setModeOparatePalletForPc(editMode, selectItem);
        }
        else {
            // SP用
            this.setModeOparatePalletForSp(editMode, selectItem);
        }

    }

    /**
     * オブジェクト操作パレットの項目表示制御(PC用)
     * @param editMode      ：編集モード
     * @param selectItem    ：選択アイテム情報
     */
    private setModeOparatePalletForPc(editMode: string, selectItem: itemVenderProperty) {

        // デフォルト文字色
        let defFontColor: GetEditInfo.GetEditInfoColorEntity = util.relic.listFind(this.editInfo.master.color, (c: GetEditInfo.GetEditInfoColorEntity) => {
            return c.id == this.editInfo.master.design.fontColor;
        });
        if (!defFontColor) {
            defFontColor = this.editInfo.master.color[0];
        }

        if (editMode === EDIT_MODE_KIND.SET_PHOTO) {
            // 画像入替・追加
            this._vue.$data.Show.OparatePalletDelStamp = false;
            this._vue.$data.Show.OparatePalletCharColor = false;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletTopPart = false;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletCover = false;
            this._vue.$data.Show.OparatePalletCover4Top = false;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false;
            this._vue.$data.Show.OparatePalletFinishSelect = true;
            this._vue.$data.Show.HideButton = false;

            if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_PRINT) {
                // 印刷専用の場合
                this._vue.$data.OparatePalletWide = false;
                this._vue.$data.Show.OparatePalletFinishSelectPrint = true;
                this._vue.$data.Show.OparatePalletFinishSelectGinen = false;
                this._vue.$data.FinishSelect.isGinen = false;

                this._vue.$data.Show.OparatePallet = false;
            }
            else if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_GINEN) {
                // 銀塩専用の場合
                this._vue.$data.OparatePalletWide = false;
                this._vue.$data.Show.OparatePalletFinishSelectPrint = false;
                this._vue.$data.Show.OparatePalletFinishSelectGinen = true;
                this._vue.$data.FinishSelect.isGinen = true;

                this._vue.$data.Show.OparatePallet = false;
            }
            else {
                // 上記以外の場合
                this._vue.$data.OparatePalletWide = true;
                this._vue.$data.Show.OparatePalletFinishSelectPrint = true;
                this._vue.$data.Show.OparatePalletFinishSelectGinen = true;
            }

        }
        else if (editMode === EDIT_MODE_KIND.MANI_PHOTO) {
            // 画像編集
            this._vue.$data.Show.OparatePalletDelStamp = false;
            this._vue.$data.Show.OparatePalletCharColor = false;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.OparatePalletClear = true;
            this._vue.$data.Show.OparatePalletPhotoCorrect = true;
            this._vue.$data.Show.OparatePalletPitaCorrect = true;
            if (selectItem !== null && selectItem.file_id !== this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID) {
                this._vue.$data.Show.OparatePalletCover = false;
            }
            else {
                this._vue.$data.Show.OparatePalletCover = true;
            }
            this._vue.$data.Show.OparatePalletCover4Top = false;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.HideButton = false;
        }
        else if (editMode === EDIT_MODE_KIND.GREETING) {
            // あいさつ文編集
            this._vue.$data.Show.OparatePalletDelStamp = false;
            this._vue.$data.Show.OparatePalletCharColor = true;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false;
            this._vue.$data.Show.OparatePalletCover = false;
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.HideButton = true;

            // 作成済みのあいさつ文が存在するか判定
            if (0 < this.sonbpIfController.GreetingList.length) {
                // あり
                this._vue.$data.Show.OparatePalletCover4Top = false;
                this._vue.$data.Show.OparatePalletCover4Bottom = false;
                this._vue.$data.GreetingInfo.UpdBtnEnable = true;
                this._vue.$data.GreetingInfo.DelBtnEnable = true;
            }
            else {
                // なし
                this._vue.$data.Show.OparatePalletCover4Top = true;
                this._vue.$data.Show.OparatePalletCover4Bottom = false;
                this._vue.$data.GreetingInfo.UpdBtnEnable = false;
                this._vue.$data.GreetingInfo.DelBtnEnable = false;
            }
            // 文字色
            this._vue.$data.SelectCharColor = defFontColor.id;
            // フチ文字色
            this._vue.$data.SelectOutlineCharColor = this.editInfo.master.color[0].id;
        }
        else if (editMode === EDIT_MODE_KIND.SENDER) {
            // 差出人情報編集
            this._vue.$data.Show.OparatePalletDelStamp = false;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false; 
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.OparatePalletCharColor = true;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletCover = false;
            this._vue.$data.Show.OparatePalletCover4Top = true;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.Show.HideButton = true;
            // 文字色
            this._vue.$data.SelectCharColor = defFontColor.id;
            // フチ文字色
            this._vue.$data.SelectOutlineCharColor = this.editInfo.master.color[0].id;
        }
        else if (editMode === EDIT_MODE_KIND.STAMP) {
            // スタンプ
            this._vue.$data.Show.OparatePalletDelStamp = true;
            this._vue.$data.Show.OparatePalletCharColor = false;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false; 
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.Show.OparatePalletCover4Top = false;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.HideButton = true;
        } else if (editMode === EDIT_MODE_KIND.MYSTAMP) {
            // Myステッカー
            this._vue.$data.Show.OparatePalletDelStamp = true;
            this._vue.$data.Show.OparatePalletCharColor = false;
            this._vue.$data.Show.OparatePalletTegakiColor = false;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false; 
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.Show.OparatePalletCover4Top = false;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.HideButton = true;
        } else if (editMode === EDIT_MODE_KIND.FONTGENIC) {
            // 手書きスタンプ
            this._vue.$data.Show.OparatePalletDelStamp = true;
            this._vue.$data.Show.OparatePalletCharColor = false;
            this._vue.$data.Show.OparatePalletTegakiColor = true;
            this._vue.$data.Show.OparatePalletTopPart = true;
            this._vue.$data.Show.OparatePalletClear = false;
            this._vue.$data.Show.OparatePalletPhotoCorrect = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = false; 
            this._vue.$data.Show.OparatePalletFinishSelect = false;
            this._vue.$data.Show.OparatePalletCover4Top = false;
            this._vue.$data.Show.OparatePalletCover4Bottom = false;
            this._vue.$data.OparatePalletWide = false;
            this._vue.$data.Show.HideButton = true;
            // 手書きスタンプ色
            this._vue.$data.SelectTegakiColor = "";
        }


    }

    /**
     * オブジェクト操作パレットの項目表示制御(SP用)
     * @param editMode      ：編集モード
     * @param selectItem    ：選択アイテム情報
     */
    public setModeOparatePalletForSp(editMode: string, selectItem: itemVenderProperty) {

        this._vue.$data.Show.OparatePalletAddGreetingItem = false;
        this._vue.$data.Show.OparatePalletAddStampItem = false;
        this._vue.$data.Show.OparatePalletAddMyStampItem = false;
        this._vue.$data.Show.OparatePalletAddTegakiStampItem = false;
        this._vue.$data.Show.OparatePalletChangeTegakiStampColor = false;
        this._vue.$data.Show.OparatePalletPitaCorrect = false,


        this._vue.$data.Show.OparatePalletEditGreetingItem = false;
        this._vue.$data.Show.OparatePalletEditSenderItem = false;

        this._vue.$data.Show.GreetingDeleteBtn = false;
        this._vue.$data.Show.SenderDeleteBtn = false;
        this._vue.$data.Show.StampDeleteBtn = false;


        if (editMode === EDIT_MODE_KIND.SET_PHOTO) {
            // 画像入替・追加
            this.returnHomeFunc(selectItem);
            if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_PRINT) {
                // 印刷専用の場合
                this._vue.$data.FinishSelect.isGinen = false;
                this._vue.$data.Show.FinishSelectMenuIcon = false;
            }
            else if (this.editInfo.master.design.printType === EditConst.PRINT_TYPE_GINEN) {
                // 銀塩専用の場合
                this._vue.$data.FinishSelect.isGinen = true;
                this._vue.$data.Show.FinishSelectMenuIcon = false;
            }
            else {
                // 上記以外の場合
                this._vue.$data.Show.FinishSelectMenuIcon = true;
            }
        }
        else if (editMode === EDIT_MODE_KIND.MANI_PHOTO) {
            // 画像編集
            this._vue.$data.Show.OparatePalletCover = false;
            this._vue.$data.Show.OparatePalletPitaCorrect = true;

        }
        else if (editMode === EDIT_MODE_KIND.GREETING) {
            // あいさつ文編集
            this.sonbpIfController.getGreetingTextList((list: itemVenderProperty[]) => {
                if (0 < list.length) {
                    this._vue.$data.Show.OparatePalletCover = false;
                    this._vue.$data.GreetingInfo.DelBtnEnable = true;
                    this._vue.$data.GreetingInfo.UpdBtnEnable = true;
                }
                else {
                    this._vue.$data.Show.OparatePalletCover = true;
                    this._vue.$data.GreetingInfo.DelBtnEnable = false;
                    this._vue.$data.GreetingInfo.UpdBtnEnable = false;
                }
            });

            this._vue.$data.Show.OparatePalletAddGreetingItem = true;
            this._vue.$data.Show.OparatePalletEditGreetingItem = true;
            this._vue.$data.Show.GreetingDeleteBtn = true;
        }
        else if (editMode === EDIT_MODE_KIND.SENDER) {
            // 差出人情報編集
            this.sonbpIfController.getSenderTextList((list: itemVenderProperty[]) => {
                if (0 < list.length) {
                    this._vue.$data.Show.OparatePalletCover = false;
                    this._vue.$data.SenderInfo.DelBtnEnable = true;
                }
                else {
                    this._vue.$data.Show.OparatePalletCover = true;
                    this._vue.$data.SenderInfo.DelBtnEnable = false;
                }
            });

            this._vue.$data.Show.OparatePalletEditSenderItem = true;
            this._vue.$data.Show.SenderDeleteBtn = true;

        }
        else if (editMode === EDIT_MODE_KIND.STAMP) {
            // スタンプ
            this.sonbpIfController.getMstStampList((list: itemVenderProperty[]) => {
                if (0 < list.length) {
                    this._vue.$data.Show.OparatePalletCover = false;
                    this._vue.$data.Stamp.DelBtnEnable = true;
                }
                else {
                    this._vue.$data.Show.OparatePalletCover = true;
                    this._vue.$data.Stamp.DelBtnEnable = false;
                }
            });

            this._vue.$data.Show.OparatePalletAddStampItem = true;
            this._vue.$data.Show.StampDeleteBtn = true;
        }
        else if (editMode === EDIT_MODE_KIND.MYSTAMP) {
            // Myステッカー
            this.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
                if (0 < list.length) {
                    this._vue.$data.Show.OparatePalletCover = false;
                    this._vue.$data.Stamp.DelBtnEnable = true;
                }
                else {
                    this._vue.$data.Show.OparatePalletCover = true;
                    this._vue.$data.Stamp.DelBtnEnable = false;
                }
            });

            this._vue.$data.Show.OparatePalletAddMyStampItem = true;
            this._vue.$data.Show.StampDeleteBtn = true;
        }
        else if (editMode === EDIT_MODE_KIND.FONTGENIC) {
            // 手書きスタンプ
            this.sonbpIfController.getTegakiStampList((list: itemVenderProperty[]) => {
                if (0 < list.length) {
                    this._vue.$data.Show.OparatePalletCover = false;
                    this._vue.$data.Stamp.DelBtnEnable = true;
                }
                else {
                    this._vue.$data.Show.OparatePalletCover = true;
                    this._vue.$data.Stamp.DelBtnEnable = false;
                }
            });

            this._vue.$data.Show.OparatePalletAddTegakiStampItem = true;
            this._vue.$data.Show.OparatePalletChangeTegakiStampColor = true;
            this._vue.$data.Show.StampDeleteBtn = true;
        }

    }

    /**
     * 全枠のサムネイル画像をまとめて取得
     */
    private getAllUploadThumbnails(): es6promise.Promise<any> {
        const that = this;

        // アップロード画像のサムネイル取得
        return new es6promise.Promise(async function (resolve, reject) {
            let promises: any[] = [];
            let err: boolean = false;

            Logger.debug("全枠のサムネイル画像をまとめて取得");

            // アップロード画像ファイル数分繰り返し
            for (let i: number = 0; i < that.uploadPhotoList.length; i++) {

                if (util.verify.isEmpty(that.uploadPhotoList[i].fileId)) {
                    continue;
                }

                Logger.debug("対象アップロード画像ファイル i[" + i + "] [" + that.uploadPhotoList[i].fileId + "]");

                // 10個ずつ実行
                promises.push(that._photoLogic.getThumbnail(that.uploadPhotoList[i].fileId, that.uploadPhotoList[i].width, that.uploadPhotoList[i].height));
                if (i % 10 == 9 || that.uploadPhotoList.length <= i + 1) {
                    await asyncWhenApply(promises).then(function () {
                        Logger.debug("アップロード画像のサムネイル取得 arguments[" + JSON.stringify(arguments) + "]");
                        promises = [];
                    }).catch(function (e) {
                        Logger.error("アップロード画像のサムネイル取得エラー", e);
                        err = true;
                    });
                }

                // 結果判定
                if (err) {
                    Logger.error("画像サムネイルダウンロード失敗");
                    break;
                }
            }

            // Myステッカーアップロード画像ファイル数分繰り返し
            promises = [];
            for (let i: number = 0; i < that.uploadMyStampList.length; i++) {

                let myStamp = that.uploadMyStampList[i];

                if (util.verify.isEmpty(myStamp.fileId)) {
                    continue;
                }

                Logger.debug("対象Myステッカーアップロード画像ファイル i[" + i + "] [" + myStamp.fileId + "]");

                // 10個ずつ実行
                promises.push(that._myStampLogic.getThumbnail(myStamp.fileId, myStamp.width, myStamp.height));
                if (i % 10 == 9 || that.uploadMyStampList.length <= i + 1) {
                    await asyncWhenApply(promises).then(function () {
                        Logger.debug("Myステッカーアップロード画像のサムネイル取得 arguments[" + JSON.stringify(arguments) + "]");
                        promises = [];
                    }).catch(function (e) {
                        Logger.error("Myステッカーアップロード画像のサムネイル取得エラー", e);
                        err = true;
                    });
                }

                // 結果判定
                if (err) {
                    Logger.error("Myステッカーサムネイルダウンロード失敗");
                    break;
                }
            }
            that.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].item_type === sonbpIfconst.ITYPE_MYSTAMP_IMG) {
                        let upstmp: uploadPhoto = util.relic.listFind(that.uploadMyStampList, (upStamp: uploadPhoto) => { return upStamp.fileId === list[i].file_id; });
                        if (upstmp) {
                            upstmp.isUsed = true;
                        }
                    }
                }
            });

            if (!err) {
                Logger.debug("Myステッカーサムネイルダウンロード全成功");
                resolve();
            } else {
                Logger.error("Myステッカーサムネイルダウンロード失敗");
                reject();
            }


            // 手書きスタンプアップロード画像ファイル数分繰り返し
            promises = [];
            for (let i: number = 0; i < that.uploadTegakiStampList.length; i++) {

                let tegaki = that.uploadTegakiStampList[i];

                if (util.verify.isEmpty(tegaki.fileId)) {
                    continue;
                }

                Logger.debug("対象手書きスタンプアップロード画像ファイル i[" + i + "] [" + tegaki.fileId + "]");

                // 10個ずつ実行
                promises.push(that._tegakiStampLogic.getThumbnail(tegaki.fileId, tegaki.width, tegaki.height));
                if (i % 10 == 9 || that.uploadTegakiStampList.length <= i + 1) {
                    await asyncWhenApply(promises).then(function () {
                        Logger.debug("手書きスタンプアップロード画像のサムネイル取得 arguments[" + JSON.stringify(arguments) + "]");
                        promises = [];
                    }).catch(function (e) {
                        Logger.error("手書きスタンプアップロード画像のサムネイル取得エラー", e);
                        err = true;
                    });
                }

                // 結果判定
                if (err) {
                    Logger.error("手書きスタンプサムネイルダウンロード失敗");
                    break;
                }
            }

            if (!err) {
                Logger.debug("画像サムネイルダウンロード全成功");
                resolve();
            } else {
                Logger.error("画像サムネイルダウンロード失敗");
                reject();
            }
        });

    }

    /**
     * ホームメニューへの遷移処理
     */
    private returnHomeFunc(selectItem: itemVenderProperty) {

        // タイトル
        this._vue.$data.Header.Title = EditConst.TITLE_MAIN;

        // 戻るボタン
        this._vue.$data.Show.ReturnFlowBtn = true;
        this._vue.$data.Show.ReturnHomeBtn = false;
        this._vue.$data.Show.ReturnHomeExBtn = false;
        this._vue.$data.Show.ReturnPhotoManiBtn = false;
        this._vue.$data.Show.ReturnGreetingHomeBtn = false;
        this._vue.$data.Show.ReturnSenderHomeBtn = false;
        this._vue.$data.Show.ReturnStampHomeBtn = false;
        this._vue.$data.Show.ReturnMyStampHomeBtn = false;
        this._vue.$data.Show.ReturnTegakiStampHomeBtn = false;
        this._vue.$data.Show.FinishSelectMenuDialog = false;
        this._vue.$data.Show.EditImageFilterMenu = false;
        this._vue.$data.Show.EditImagePitaMenu = false;
        // 次へボタン
        this._vue.$data.Show.NextFlowBtn = true;
        this._vue.$data.Show.NextHomeFromImgListBtn = false;
        this._vue.$data.Show.NextHomeFromMyStampListBtn = false;
        this._vue.$data.Show.NextHomeFromTegakiStampListBtn = false;
        this._vue.$data.Show.CommitNextHomeBtn = false;
        // 削除ボタン
        this._vue.$data.Show.PhotoDeleteBtn = false;
        this._vue.$data.Show.MyStampListTrashBtn = false;
        this._vue.$data.Show.TegakiStampListTrashBtn = false;
        this._vue.$data.Show.GreetingDeleteBtn = false;
        this._vue.$data.Show.SenderDeleteBtn = false;
        this._vue.$data.Show.StampDeleteBtn = false;
        // 更新ボタン
        this._vue.$data.Show.GreetingUpdataBtn = false;

        // 編集エリア
        this._vue.$data.Show.EditArea = true;
        this._vue.$data.Show.MyStampList = false;
        this._vue.$data.Show.TegakiStampList = false;
        // 画像一覧
        this._vue.$data.Show.PhotoList = false;
        // あいさつ文パネル
        this._vue.$data.Show.GreetingPanel = false;
        // 差出人パネル
        this._vue.$data.Show.SenderPanel = false;
        // スタンプパネル
        this._vue.$data.Show.StampPanel = false;
        this._vue.$data.Show.MyStampPanel = false;
        this._vue.$data.Show.TegakiStampPanel = false;
        this._vue.$data.Show.TegakiColorPanel = false;

        // フッターメニュー
        this._vue.$data.Show.FooterMenu = true;
        // オブジェクト操作メニュー
        this._vue.$data.Show.OparatePallet = false;
        this._vue.$data.Show.OparatePalletChangeBright = false;

        // メインメニュー表示
        this._vue.$data.Show.EditImageMenu = false;
        this._vue.$data.Show.SetPhotoMenu = true;

        // メインメニュー表示 ＝ アイテム未選択
        this.sonbpIfController.selectItemClear();
    }

    /**
     * 仕上がりのメッセージをセットする。
     * @param isGinen
     */
    private setImgGuidanceMesage(isGinen: boolean)
    {
        // 仕上がり変更したらメッセージを表示
        this._vue.$data.Show.ImgGuidance = true;
        const msg = isGinen ? EditConst.IMAGE_GUIDANCE_MESSAGE_GINEN : EditConst.IMAGE_GUIDANCE_MESSAGE_INSATSU;
        this._vue.$data.ImgGuidanceMessage = msg;
    }

// #endregion

// #region ■イベント
    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

// #region ■イベント（画面遷移関連）

    /**
     * 前画面遷移ボタン押下メソッド
     * @param event
     */
    public btnClickReturnFlow(event: JQueryEventObject): void {

        Logger.debug("前画面遷移ボタン押下メソッド [" + /*this._retailerConfig.editReturnBtn +*/ "]");

        this._saveLogic.saveReady(true, this._saveLogic.saveBodyForReturnFlow);
    }

    /**
     * 前画面遷移ボタン押下メソッド(ガイダンス表示)(PC用)
     * @param event
     */
    public btnClickReturnFlowFromGuidance(event: JQueryEventObject): void {

        Logger.debug("前画面遷移ボタン押下メソッド(ガイダンス) [" + /*this._retailerConfig.editReturnBtn +*/ "]");

        let showConfirmDlg: boolean = false;

        // 画像枠ありのテンプレートか判定
        if (this.sonbpIfController.ExistsPhotoBox) {
            // ありの場合
            showConfirmDlg = false;
        }
        else {
            // 上記以外の場合
            showConfirmDlg = true;
        }

        this._saveLogic.saveReady(showConfirmDlg, this._saveLogic.saveBodyForReturnFlow);
    }

    /**
     * 次画面遷移ボタン押下メソッド
     * */
    public btnClickNextFlow(event: JQueryEventObject): void {

        // sonbpの画像とアップロード一覧のチェック
        let msg = this.checkSonbpList();
        if (msg) {
            util.dialogUtil.createErrorDialog(
                msg,
                () => {
                    util.dialogUtil.closeErrorDialog();
                },
                util.dialogUtil.DialogType.Warning
            )
            // 不整合あればここで処理終了
            return;
        }

        let emptyItems: string[] = [];
        let useConfirm: boolean = false;

        // あいさつ文の登録数判定
        this.sonbpIfController.getGreetingTextList((greetingList: itemVenderProperty[]) => {
            if (this.editInfo.master.design.editMode != EditConst.DSN_MST_EDIT_MODE_LIMIT) {
                if (greetingList.length === 0) {
                    useConfirm = true;
                    emptyItems.push("・あいさつ文");
                }
            }

            // 差出人情報の登録数判定
            if (this._vue.$data.Show.SenderMenu === true) {
                this.sonbpIfController.getSenderTextList((senderList: itemVenderProperty[]) => {
                    if (senderList.length === 0) {
                        useConfirm = true;
                        emptyItems.push("・差出人情報");
                    }
                    this.nextFlowFunc(useConfirm, emptyItems);

                });
            }
            else {
                this.nextFlowFunc(useConfirm, emptyItems);
            }
        });

    }

    /**
     * 次画面遷移ボタン押下処理本体
     * @param useConfirm    ：確認メッセージ必要？
     * @param emptyItems     ：登録数０件の項目名
     */
    private nextFlowFunc(useConfirm: boolean, emptyItems: string[]) {

        // 判定
        if (!useConfirm) {
            this._saveLogic.saveReady(true, this._saveLogic.saveBody);
        }
        else {
            let msg: string = constDialogMessage.INFO_EDIT_NEXTPAGE_CHECK;
            msg = msg + "<br>" + emptyItems.join("<br>");

            // 確認メッセージ表示
            util.dialogUtil.createYesNoDialog(
                msg,
                () => {
                    util.dialogUtil.closeYesNoDialog();
                    this._saveLogic.saveReady(true, this._saveLogic.saveBody);
                },
                util.dialogUtil.closeYesNoDialog,
                EditConst.NEXTPAGE_CONFIRM_YES, EditConst.NEXTPAGE_CONFIRM_NO,
                util.dialogUtil.DialogType.Infomation)
        }

    }

    /**
     * ユーザがアップロードした画像一覧にない画像をsonbpが使用していないかチェック
     * return 空文字:不整合無し
     *        ダイアログメッセージ:不整合有り(sonbpの画像がアップロード一覧にない。)
     * */
    private checkSonbpList(): string{

        // sonbpの使用一覧を取得する。
        let photoList: string[];
        let mystampList: string[];
        let fontgenicList: string[];
        this.sonbpIfController.getPhotoList((list: itemVenderProperty[]) => {
            photoList = list.map(v => v.file_id).filter(v => v !== this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID);
        }, () => { });
        this.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
            mystampList = list.map(v => v.file_id);
        });
        this.sonbpIfController.getTegakiStampList((list: itemVenderProperty[]) => {
            fontgenicList = list.map(v => v.file_id);
        });

        // チェック用ローカル関数
        function CheckDiff(uploadList: uploadPhoto[], sonbpListWithAtmark: string[]) :boolean{
            // アップロード一覧からIDのリスト作成(不要な@は取り除く)
            let uploadFileKeyList = uploadList.map(x => {
                return x.fileId;
            }).filter(x => x != undefined);
            let sonbpList = sonbpListWithAtmark.map(x => {
                return x?.split('@')[0];
            }).filter(x => x != undefined);
            Logger.log("sonbpList:", sonbpList);
            Logger.log("uploadList:", uploadFileKeyList);
            // sonbpとアップロード一覧を突き合わせ結果(sonbpだけに存在しているものはfalse)
            let diff = sonbpList.map(x => {
                return {
                    isExist: uploadFileKeyList.includes(x),
                    id: x
                }
            });
            if (diff.filter(x => x.isExist == false).length > 0) {
                return false;
            }
            return true;
        }

        if (!CheckDiff(this.uploadPhotoList, photoList)) {
            return constDialogMessage.WARN_EDIT_CHECK_SONBP_UPLOADIMAGES_DIFF;
        } else if (!CheckDiff(this.uploadMyStampList, mystampList)) {
            return constDialogMessage.WARN_EDIT_CHECK_SONBP_UPLOADMYSTAMPS_DIFF;
        } else if (!CheckDiff(this.uploadTegakiStampList, fontgenicList)) {
            return constDialogMessage.WARN_EDIT_CHECK_SONBP_UPLOADTEGAKISTAMPS_DIFF;
        }

        return "";
    }

    /**
     * ヘッダーの最初に戻る押下
     * @param event
     * @override
     */
    public btnClickReturnTop(event: JQueryEventObject): void {
        Logger.debug("最初に戻るボタン押下メソッド ");
        this._saveLogic.saveReady(true, this._saveLogic.saveBodyForReturnFlow);
    }

    /**
     * 操作方法ボタン押下メソッド
     * */
    public btnClickOperationHelp(event: JQueryEventObject): void {
        util.ui.windowOpen(this._retailerConfig.operationInfo.edit);
    }

    /**
     * プリント領域についてリンク押下メソッド
     * */
    public linkClickPrintWarning(event: JQueryEventObject): void {
        util.ui.windowOpen(this._retailerConfig.printWarning);
    }


// #endregion

// #region ■イベント（操作補助関連）

    /**
     * ガイダンス２の戻るボタン押下メソッド(SP用)
     * */
    public btnClickGuidance2Prev(event: JQueryEventObject): void {

        this._vue.$data.Show.Guidance1 = true;
        this._vue.$data.Show.Guidance2 = false;
        this._vue.$data.Show.Guidance3 = false;
        this._vue.$data.Show.Guidance4 = false;
        this._vue.$data.Show.Guidance5 = false;

    }

    /**
     * ガイダンス１の×ボタン押下メソッド(SP用)
     * */
    public btnClickCloseGuidance1(event: JQueryEventObject, isBack?: boolean): void {

        if (this._vue.$data.Show.Guidance1 || (this._vue.$data.Show.Guidance3 && isBack)) {
            this._vue.$data.Show.Guidance1 = false;
            this._vue.$data.Show.Guidance2 = true;
            this._vue.$data.Show.Guidance3 = false;
            this._vue.$data.Show.Guidance4 = false;
            this._vue.$data.Show.Guidance5 = false;
        }
    }

    /**
     * ガイダンス２の×ボタン押下メソッド(SP用)
     * */
    public btnClickCloseGuidance2(event: JQueryEventObject, isBack?: boolean): void {

        if (this._vue.$data.Show.Guidance2 || (this._vue.$data.Show.Guidance4 && isBack)) {
            this._vue.$data.Show.Guidance1 = false;
            this._vue.$data.Show.Guidance2 = false;
            this._vue.$data.Show.Guidance3 = true;
            this._vue.$data.Show.Guidance4 = false;
            this._vue.$data.Show.Guidance5 = false;
        }

    }
    public btnClickCloseGuidance3(event: JQueryEventObject, isBack?: boolean): void {
        if (this._vue.$data.Show.Guidance3 || (this._vue.$data.Show.Guidance5 && isBack)) {
            this._vue.$data.Show.Guidance1 = false;
            this._vue.$data.Show.Guidance2 = false;
            this._vue.$data.Show.Guidance3 = false;
            this._vue.$data.Show.Guidance4 = true;
            this._vue.$data.Show.Guidance5 = false;
        }
    }
    public btnClickCloseGuidance4(event: JQueryEventObject): void {
        if (this._vue.$data.Show.Guidance4) {
            this._vue.$data.Show.Guidance1 = false;
            this._vue.$data.Show.Guidance2 = false;
            this._vue.$data.Show.Guidance3 = false;
            this._vue.$data.Show.Guidance4 = false;
            this._vue.$data.Show.Guidance5 = true;
        }
    }
    public btnClickCloseGuidance5(event: JQueryEventObject): void {
        if (this._vue.$data.Show.Guidance5) {
            this._vue.$data.Show.Guidance1 = false;
            this._vue.$data.Show.Guidance2 = false;
            this._vue.$data.Show.Guidance3 = false;
            this._vue.$data.Show.Guidance4 = false;
            this._vue.$data.Show.Guidance5 = false;
        }
        this._vue.$data.Show.ScreenLock = false;
    }

    /**
     * ツールメニュー：仕上がり選択押下メソッド(画像枠＝０の場合の特殊メニュー)
     * */
    public btnClickFinishSelectMenu(event: JQueryEventObject): void {

        if (this.editMode === EDIT_MODE_KIND.SET_PHOTO) {
            return;
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(EDIT_MODE_KIND.SET_PHOTO,
            () => {
                // 正常終了の場合
                this.editMode = EDIT_MODE_KIND.SET_PHOTO;
                // パネルの表示制御
                this._vue.$data.Show.BalloonGuidance = false;
                this._vue.$data.Show.PhotoList = false;
                this._vue.$data.Show.OparatePallet = true;
                this._vue.$data.Show.GreetingPanel = false;
                this._vue.$data.Show.SenderPanel = false;
                this._vue.$data.Show.StampPanel = false;
                this._vue.$data.Show.MyStampPanel = false;
                this._vue.$data.Show.TegakiStampPanel = false;
                this._vue.$data.Show.TegakiColorPanel = false;

                // ツールメニューの活性制御
                this._vue.$data.ActiveSetPhotoMenu = false;
                this._vue.$data.ActiveManiPhotoMenu = false;
                this._vue.$data.ActiveGreetingMenu = false;
                this._vue.$data.ActiveSenderMenu = false;
                this._vue.$data.ActiveStampMenu = false;
                this._vue.$data.ActiveMyStampMenu = false;
                this._vue.$data.ActiveTegakiStampMenu = false;
                this._vue.$data.ActiveFinishSelectMenu = true;

                // オブジェクト操作パレットの表示制御
                this.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });

    }

    /**
     * 画像の赤枠ガイダンスを消す
     * @param event
     */
    public btnClickImgGuidance(event: JQueryEventObject): void {
        this._vue.$data.Show.ImgGuidance = false;
    }

    /**
     * 操作メニュー(入力欄を隠す)
     * @param event
     */
    public btnClickHideInputArea(event: JQueryEventObject): void {
        if (this.editMode === EDIT_MODE_KIND.GREETING) {
            //console.log("greet");
            if (this._vue.$data.GreetingInfo.fade.Out) {
                //console.log("フェードイン");
                this._vue.$data.GreetingInfo.fade.In = true;
                this._vue.$data.GreetingInfo.fade.Out = false;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
            } else {
                //console.log("フェードアウト");
                this._vue.$data.GreetingInfo.fade.In = false;
                this._vue.$data.GreetingInfo.fade.Out = true;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_IN;
            }
        } else if (this.editMode === EDIT_MODE_KIND.SENDER) {
            //console.log("sender");
            if (this._vue.$data.SenderInfo.fade.Out) {
                //console.log("フェードイン");
                this._vue.$data.SenderInfo.fade.In = true;
                this._vue.$data.SenderInfo.fade.Out = false;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
            } else {
                //console.log("フェードアウト");
                this._vue.$data.SenderInfo.fade.In = false;
                this._vue.$data.SenderInfo.fade.Out = true;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_IN;
            }
        } else if (this.editMode === EDIT_MODE_KIND.STAMP) {
            //console.log("stamp");
            if (this._vue.$data.Stamp.fade.Out) {
                //console.log("フェードイン");
                this._vue.$data.Stamp.fade.In = true;
                this._vue.$data.Stamp.fade.Out = false;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
            } else {
                //console.log("フェードアウト");
                this._vue.$data.Stamp.fade.In = false;
                this._vue.$data.Stamp.fade.Out = true;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_IN;
            }
        } else if (this.editMode === EDIT_MODE_KIND.MYSTAMP) {
            //console.log("stamp");
            if (this._vue.$data.MyStamp.fade.Out) {
                //console.log("フェードイン");
                this._vue.$data.MyStamp.fade.In = true;
                this._vue.$data.MyStamp.fade.Out = false;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
            } else {
                //console.log("フェードアウト");
                this._vue.$data.MyStamp.fade.In = false;
                this._vue.$data.MyStamp.fade.Out = true;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_IN;
            }
        } else if (this.editMode === EDIT_MODE_KIND.FONTGENIC) {
            //console.log("stamp");
            if (this._vue.$data.TegakiStamp.fade.Out) {
                //console.log("フェードイン");
                this._vue.$data.TegakiStamp.fade.In = true;
                this._vue.$data.TegakiStamp.fade.Out = false;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
            } else {
                //console.log("フェードアウト");
                this._vue.$data.TegakiStamp.fade.In = false;
                this._vue.$data.TegakiStamp.fade.Out = true;
                this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_IN;
            }
        }
    }

    /**
     * ホームへ戻る(/決定)ボタン押下(SP)
     * @param doSetMode     ：モード変更する？
     * @param doCommit      ：コミットする？
     * @param event         ：
     */
    public btnClickReturnHome(doSetMode: boolean, doCommit: boolean, event: JQueryEventObject): void {

        Logger.debug("ホームへ戻るボタン押下 mode=[" + this.editMode + "]");

        // 選択アイテム取得
        let selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
        Logger.debug("選択アイテム取得", selectItem);

        if (doSetMode) {
            // モード変更
            this.sonbpIfController.setMode(EDIT_MODE_KIND.SET_PHOTO, () => {
                this.editMode = EDIT_MODE_KIND.SET_PHOTO;

                // タッチイベント制御(有効)
                this.touchEventChange(true);

                if (doCommit) {
                    // 操作確定
                    // 面倒くさいが、決定が押された時にスタンプ使用フラグを立ててやる必要がある
                    this.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
                        for (let i = 0; i < list.length;i++) {
                            if (list[i].item_type === sonbpIfconst.ITYPE_MYSTAMP_IMG) {
                                let upstmp: uploadPhoto = util.relic.listFind(this.uploadMyStampList, (upStamp: uploadPhoto) => { return upStamp.fileId === list[i].file_id; });
                                if (upstmp) {
                                    upstmp.isUsed = true;
                                }
                            }
                        }
                    });

                    this.sonbpIfController.historyCommit();
                    this.returnHomeFunc(selectItem);
                }
                else {
                    // 操作取り消し
                    this.sonbpIfController.historyAllUndo(
                        () => {

                            // SPの戻るはロールバックなので、スタンプの利用有無を再同期
                            this.resetUsedOfStamps();

                            this.returnHomeFunc(selectItem);
                        }, () => {
                            dialogUtil.createErrorDialog(
                                constDialogMessage.ERROR_EDIT_ROLLBACK,
                                () => {
                                    dialogUtil.closeErrorDialog
                                    this.returnHomeFunc(selectItem);
                                });
                        });
                }

            }, () => { })
        }
        else {
            this.returnHomeFunc(selectItem);
        }
    }

    /**
     * メニュー戻るボタン押下(SP)
     * @param event
     */
    public btnClickReturnMainMenu(event: JQueryEventObject): void {

        Logger.debug("メニュー戻るボタン押下");

        // 選択解除
        this.sonbpIfController.selectItemClear();
        // 操作メニュー非表示
        this._vue.$data.Show.EditImageMenu = false;
        // メインメニュー表示
        this._vue.$data.Show.SetPhotoMenu = true;
    }

    /**
     * メニュースクロール(SP)
     * @param id
     */
    public setScrollMenuList(id: string): void {
        if (!$(`#${id}`) || !$(`#${id}`).prop('scrollWidth')) {
            return;
        }
        
        this._vue.$data.Show.ScrollList[id].isBtnHidden = $(`#${id}`).width() == $(`#${id}`).prop('scrollWidth');
        this._vue.$data.Show.ScrollList[id].isMenuScrollLeftDisabled = $(`#${id}`).scrollLeft() == 0;
        this._vue.$data.Show.ScrollList[id].isMenuScrollRightDisabled = ($(`#${id}`).scrollLeft() + $(`#${id}`).width() >= $(`#${id}`).prop('scrollWidth'));
        //console.log(`leftWidth(${$(`#${id}`).scrollLeft()})+width(${$(`#${id}`).width()})>=Scroll(${$(`#${id}`).prop('scrollWidth')})`);
    }

// #endregion

// #endregion

// #region ■内部関数
    //--------------------------------------------------------------------------
    // 内部関数
    //--------------------------------------------------------------------------

    /**
     * sonbpへ通知するページエリアサイズを算出
     */
    private calcSonbpPageAreaSize(): { width: number, height: number } {

        let pageAreaHeight: number;

        // フレームIDの高さ取得
        const framIdHeight: number = $(".p-editCanvasArea__framId").outerHeight(true);
        // プリント領域リンクの高さ取得
        const printWarningHeight: number = $("#printWarning").height();
        // 編集エリアのサイズ
        const editAreaHeight: number = $("#editArea").height();

        Logger.debug("editH[" + editAreaHeight + "] frameH[" + framIdHeight + "] warH[" + printWarningHeight + "]");

        // ページエリアのサイズ算出
        pageAreaHeight = editAreaHeight - (framIdHeight * 2) - (printWarningHeight * 2);

        Logger.debug("ページエリアのサイズ(高さ)[" + pageAreaHeight + "]");

        // 高さ基準で正方形
        let setWidth: number = pageAreaHeight;
        let setHeight: number = pageAreaHeight;

        return {
            width: setWidth,
            height: setHeight
        };
    }

    /**
     * プレビュー画面からきた判定をします。
     * プレビュー画面からであればtrue
     * それ以外であればfalse
     */
    private checkFromPrev(): boolean {
        // まずはリファラで判定
        const referrer = document.referrer;
        const sessionStorageFlg = this.checkFromPrev_SessionStorage();
        if (referrer) {
            const splited = referrer.split('/');
            if (splited[splited.length - 1].toLowerCase() == "preview") {
                Logger.debug("戻る判定:リファラPreview");
                return true;
            }
        }
        // 最後はブラウザバックで判定。
        if (window.performance.navigation.type == 2) {
            // 戻るボタンを押されたとき
            // プレビューはブラウザバックからのみで編集画面に戻る
            if (sessionStorageFlg) {
                Logger.debug("戻る判定:ブラウザバック");
                return true;
            }
        }

        return false;

    }

    /**
     * F5チェック
     */
    private checkBrowserReload(): boolean {
        // F5は。
        if (window.performance.navigation.type == 1) {
            return true;
        }
        return false;
    }

    /**
     * 前回プレビュー画面だったかどうかの判定。
     * プレビュー画面のロード時にtrueをセットしている。
     */
    private checkFromPrev_SessionStorage(): boolean {

        let fromPrev = sessionStorage.getItem(EditConst.SESSION_STORAGE_FROM_PREV);
        if (fromPrev && fromPrev == "true") {
            Logger.info("プレビュー画面からの遷移");
            sessionStorage.removeItem(EditConst.SESSION_STORAGE_FROM_PREV);
            return true;
        }
        return false;
        //return false;
    }

    /**
     * F5リロードされるとPDFそのままなのにアップロード一覧だけidb引継ぎで差異発生するため補完する。
     */
    private resetUpdateListOfStamps() {

        let hokanFunc = (usedList: itemVenderProperty[], upList: uploadPhoto[], dbList: any, max: number) => {

            let idx = 0;

            for (; idx < max; idx++) {
                if (upList[idx].isEmpty) break;
            }

            for (let i = 0; i < usedList.length; i++) {
                let vp = usedList[i];
                let targetId = vp.file_id.split('@')[0];
                let upRow = util.relic.listFind(upList, (row) => { return row.fileId === targetId });
                let dbRow = util.relic.listFind(dbList, (row) => { return row.fileId === targetId });
                if (!upRow && dbRow) {
                    // DBからの補完
                    const ulp = upList[idx];
                    ulp.fileId = dbRow.fileId;
                    ulp.isUsed = true;
                    ulp.width = dbRow.width;
                    ulp.height = dbRow.height;
                    ulp.uploadDate = dbRow.uploadDate
                    ulp.fileName = dbRow.uploadFileName;
                    ulp.isEmpty = false;
                    ulp.fileKey = "";

                    idx++;
                }
            }
        }

        // マイスタンプのアップロード一覧補完
        this.sonbpIfController.getMyStampList((vpList: itemVenderProperty[]) => {
            hokanFunc(vpList, this.uploadMyStampList, this.editInfo.info.myStamp, this._myStampLogic.UploadNumMax());
        });

        // 手書きスタンプのアップロード一覧補完
        this.sonbpIfController.getTegakiStampList((vpList: itemVenderProperty[]) => {
            hokanFunc(vpList, this.uploadTegakiStampList, this.editInfo.info.fontgenic, this._tegakiStampLogic.UploadNumMax());
        });

        // 画像のアップロード一覧補完
        this.sonbpIfController.getPhotoList((vpList: itemVenderProperty[]) => {
            hokanFunc(vpList, this.uploadPhotoList, this.editInfo.info.photo, this._photoLogic.UploadNumMax());
        }, () => { });
    }

    /**
     * 削除前にモード切換えを考慮し、モード切り替えたら画像削除モードOFFして削除選択をALLクリアする
     */
    private reqDelAllclear(mode: editModeKind) {

        //if (this.editMode === mode) return;

        this.Vue.$data.UploadListModeSelect = true;

        let list = this.uploadPhotoList;
        if (mode == EDIT_MODE_KIND.MYSTAMP) list = this.uploadMyStampList;
        if (mode == EDIT_MODE_KIND.FONTGENIC) list = this.uploadTegakiStampList;

        list.forEach(row => {
            row.reqDelete = false;
            row.selected = EditConst.IMG_NOSELECT;
        });
    }

    /**
     * Sonbp-Canvasのスタンプ配置内容に合わせてアップロードリストの利用フラグを初期化する
     */
    private resetUsedOfStamps() {

        let that = this;

        let setFunc = (usedList: itemVenderProperty[], uploadList: uploadPhoto[]) => {
            uploadList.forEach(row => {
                if (row.isEmpty) {
                    row.isUsed = false;
                } else {
                    let targetId = row.fileId
                    let used: itemVenderProperty = util.relic.listFind(usedList, (vp: itemVenderProperty) => { return vp.file_id.split('@')[0] === targetId });
                    row.isUsed = used != undefined;
                }
            });
        };

        // マイスタンプの利用有無同期
        this.sonbpIfController.getMyStampList((vpList: itemVenderProperty[]) => {
            setFunc(vpList, that.uploadMyStampList);
        });

        // 手書きスタンプの利用有無同期
        this.sonbpIfController.getTegakiStampList((vpList: itemVenderProperty[]) => {
            setFunc(vpList, that.uploadTegakiStampList);
        });

        // 写真の利用有無同期
        // ※再編集後に新規注文始めた場合、idbの写真が利用フラグONのまま残るのを回避
        this.sonbpIfController.getPhotoList((list: itemVenderProperty[]) => {
            let usedIds = Enumerable.from(list).select(v => v.file_id.split('@')[0]).where(v => v != this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID).toArray();
            this.uploadPhotoList.forEach(row => {
                let uploadId = row.fileId;
                row.isUsed = usedIds.indexOf(uploadId) >= 0;
            });
        }, () => { });
    }

// #endregion

}

